webpackJsonp([1],{

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectStore_vue__ = __webpack_require__(111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5997712c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectStore_vue__ = __webpack_require__(341);
function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_selectStore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5997712c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_selectStore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'selectStore',
  data: function data() {
    return {
      selectBranch: '',
      selectPOS: '',
      currentBranchPOS: ''
    };
  },

  props: ['cancelBtn'],
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])({
    fetchBranch: 'fetchBranch',
    initState: 'initState',
    clearAllData: 'clearAllData',
    setSellsukiAuth: 'setSellsukiAuth',
    setIsloading: 'setIsloading',
    init: 'init'
  }), {
    confirmSelect: function confirmSelect() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var results;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.selectBranch === '' || _this.selectPOS === '')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                results = {
                  branch_id: _this.selectBranch.id,
                  store_id: _this.selectBranch.store_id,
                  unit_id: _this.selectBranch.unitID[_this.selectPOS],
                  warehouse: _this.selectBranch.posWarehouse[_this.selectPOS],
                  tax_id: _this.selectBranch.tax_id,
                  name: _this.selectBranch.name,
                  warehouse_display_name: _this.selectBranch.posWarehouseDisplayName[_this.selectPOS],
                  pos_id: _this.selectBranch.posID[_this.selectPOS]
                };

                _this.setIsloading(true);
                window.localStorage.setItem('currentBranchPOS', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(results));
                _this.initState();
                _this.clearAllData();
                _context.next = 9;
                return _this.init();

              case 9:
                _this.setIsloading(false);
                window.location.reload();

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cancel: function cancel() {
      this.$parent.close();
    },
    logout: function logout() {
      var _this2 = this;

      this.$dialog.confirm({
        title: 'ยืนยันการออกจากระบบ',
        message: '<center>คุณต้องการออกจากระบบใช่หรือไม่ ?</center>',
        cancelText: 'ไม่ใช่',
        confirmText: 'ใช่',
        onConfirm: function onConfirm() {
          _this2.setSellsukiAuth('');
          window.localStorage.removeItem('currentBranchPOS');
          window.location.href = "https://oms-login.akitahub.com/#/logout?target=seller-pos";
        }
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    branchs: 'getBranch',
    mainColor: 'mainColor'
  })),
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var currentBranchID, index;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this3.setIsloading(true);
              _context2.next = 3;
              return _this3.fetchBranch();

            case 3:
              if (_this3.branchs.length === 0) {
                _this3.$toast.open({
                  type: 'is-warning',
                  message: '\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E32\u0E02\u0E32',
                  position: 'is-top-right',
                  duration: '5000',
                  queue: false
                });
              }
              if (_this3.cancelBtn) {
                currentBranchID = Object(__WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__["a" /* getBranchID */])();
                index = _this3.branchs.findIndex(function (obj) {
                  return obj.id === currentBranchID;
                });

                _this3.selectBranch = _this3.branchs[index];
              }
              _this3.setIsloading(false);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },

  watch: {
    selectBranch: function selectBranch() {
      if (this.selectBranch.posID.length === 0) {
        this.$toast.open({
          type: 'is-warning',
          message: '\u0E2A\u0E32\u0E02\u0E32\u0E19\u0E35\u0E49\u0E44\u0E21\u0E48\u0E21\u0E35\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07 POS \u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E2A\u0E32\u0E02\u0E32',
          position: 'is-top-right',
          duration: '5000',
          queue: false
        });
      }
      this.selectPOS = '';
    }
  }
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http_request__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__ = __webpack_require__(6);










var OrderProvider = function (_HttpRequest) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(OrderProvider, _HttpRequest);

  function OrderProvider() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, OrderProvider);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OrderProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(OrderProvider)).call(this, "https://oms-api.akitahub.com/"));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(OrderProvider, [{
    key: 'posCompleteCart',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(params) {
        var _ref2, results;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["f" /* getStoreBearer */])();

              case 3:
                _context.t1 = _context.sent;
                _context.t2 = {
                  'Authorization': _context.t1
                };

                _context.t0.setHeader.call(_context.t0, _context.t2);

                _context.next = 8;
                return this.create('/bill/poscompletecart', params.data);

              case 8:
                _ref2 = _context.sent;
                results = _ref2.data.results;
                return _context.abrupt('return', results);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function posCompleteCart(_x) {
        return _ref.apply(this, arguments);
      }

      return posCompleteCart;
    }()
  }, {
    key: 'init',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref4, data, billExpire, paymentChannel;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = this;
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["f" /* getStoreBearer */])();

              case 3:
                _context2.t1 = _context2.sent;
                _context2.t2 = {
                  'Authorization': _context2.t1
                };

                _context2.t0.setHeader.call(_context2.t0, _context2.t2);

                _context2.next = 8;
                return this.get('/init');

              case 8:
                _ref4 = _context2.sent;
                data = _ref4.data;
                billExpire = data.results.store.default_bill_expire_day;
                paymentChannel = data.results.store_payment_channel.map(function (payment) {
                  return {
                    id: payment.spc.id,
                    payment_name: payment.pc.name,
                    payment_channel_id: payment.spc.payment_channel_id,
                    logo: payment.pc.logo
                  };
                });
                return _context2.abrupt('return', {
                  billExpire: billExpire,
                  paymentChannel: paymentChannel,
                  initData: data.results
                });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _ref3.apply(this, arguments);
      }

      return init;
    }()
  }]);

  return OrderProvider;
}(__WEBPACK_IMPORTED_MODULE_7__http_request__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (OrderProvider);

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http_request__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js__);











var PrintProvider = function (_HttpRequest) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(PrintProvider, _HttpRequest);

  function PrintProvider() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PrintProvider);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PrintProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PrintProvider)).call(this, '' + "https://gw-print-proxy-api.akitahub.com"));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PrintProvider, [{
    key: 'getPrinters',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(branchId) {
        var newStore, _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newStore = __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] ? __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] : '000000000';
                _context.next = 3;
                return this.get('/public/' + newStore.id + '/printers/' + branchId);

              case 3:
                _ref2 = _context.sent;
                data = _ref2.data;
                return _context.abrupt('return', data);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPrinters(_x) {
        return _ref.apply(this, arguments);
      }

      return getPrinters;
    }()
  }, {
    key: 'printReceipt',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(payload) {
        var newStore, _ref4, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                newStore = __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] ? __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] : '000000000';
                _context2.next = 3;
                return this.create('/public/' + newStore.id + '/prints/receipt', payload);

              case 3:
                _ref4 = _context2.sent;
                data = _ref4.data;
                return _context2.abrupt('return', data);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function printReceipt(_x2) {
        return _ref3.apply(this, arguments);
      }

      return printReceipt;
    }()
  }, {
    key: 'printReportZ',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(payload) {
        var newStore, _ref6, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                newStore = __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] ? __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] : '000000000';
                _context3.next = 3;
                return this.create('/public/' + newStore.id + '/prints/report-z', payload);

              case 3:
                _ref6 = _context3.sent;
                data = _ref6.data;
                return _context3.abrupt('return', data);

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function printReportZ(_x3) {
        return _ref5.apply(this, arguments);
      }

      return printReportZ;
    }()
  }]);

  return PrintProvider;
}(__WEBPACK_IMPORTED_MODULE_7__http_request__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PrintProvider);

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListProduct__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helper_localStorage__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    ListProduct: __WEBPACK_IMPORTED_MODULE_3__ListProduct__["a" /* default */]
  },
  data: function data() {
    return {
      page: 1,
      search: '',
      activeModal: false,
      branchName: ''
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['setSearchKey', 'loadProductMore', 'setIsloading']), {
    getBranch: function getBranch() {
      var getItem = window.localStorage.getItem('currentBranchPOS');
      var result = JSON.parse(getItem);
      return result;
    },
    searchData: function searchData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var hasProduct;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setIsloading(true);
                _context.next = 3;
                return _this.setSearchKey(_this.search);

              case 3:
                hasProduct = _context.sent;

                _this.setIsloading(false);
                if (!hasProduct) {
                  _this.$dialog.alert({
                    title: 'เกิดข้อผิดพลาด',
                    confirmText: 'ตกลง',
                    message: '<center>ข้อมูลไม่ตรงกับสินค้าในระบบ</center>'
                  });
                }

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    scrollHanle: function scrollHanle(evt) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var scrollBottom, height;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                scrollBottom = evt.target.scrollTop + evt.target.clientHeight;
                height = evt.target.scrollHeight;

                if (!(evt.target.scrollTop !== 0 && scrollBottom === height)) {
                  _context2.next = 8;
                  break;
                }

                if (!(_this2.productsNumber % 25 === 0)) {
                  _context2.next = 8;
                  break;
                }

                _this2.setIsloading(true);
                _context2.next = 7;
                return _this2.loadProductMore(++_this2.page);

              case 7:
                _this2.setIsloading(false);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    amount: 'getItemsAmount',
    searchKey: 'getSearchKey',
    products: 'getProduct',
    productsNumber: 'productsNumber',
    storeName: 'storeName',
    mainColor: 'mainColor'
  })),
  created: function created() {
    this.search = this.searchKey;
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this3.branchName = Object(__WEBPACK_IMPORTED_MODULE_5__utils_helper_localStorage__["b" /* getBranchName */])();

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'list-product',
  props: ['products', 'searchKey'],
  data: function data() {
    return {
      amountItem: 1
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['addItem']), {
    addItemData: function addItemData(item) {
      for (var i = 0; i < this.amountItem; i++) {
        this.addItem(item);
      }
    }
  }),
  watch: {
    amountItem: function amountItem(val) {
      if (val <= 0) {
        this.amountItem = 1;
      }
    }
  }
});

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'scan-search',
  data: function data() {
    return {
      paused: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    mainColor: 'mainColor'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    onDecode: function onDecode(content) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var contents, idOfProdect, hasProduct;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!content) {
                  _context.next = 9;
                  break;
                }

                contents = content.split('/');
                idOfProdect = contents[contents.length - 1];
                _context.next = 5;
                return _this.setSearchKey(idOfProdect);

              case 5:
                hasProduct = _context.sent;

                _this.playSound();
                _this.$router.push({ name: 'Home' });
                if (!hasProduct) {
                  _this.$dialog.alert({
                    title: 'เกิดข้อผิดพลาด',
                    confirmText: 'ตกลง',
                    message: '<center>ข้อมูลไม่ตรงกับสินค้าในระบบ</center>'
                  });
                }

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    playSound: function playSound() {
      var audio = new Audio(__webpack_require__(400));
      audio.play();
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setSearchKey']))
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ListCart__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_tel_input__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_tel_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_tel_input__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cart',
  data: function data() {
    return {
      tel: '',
      promoCode: '',
      phone: {},
      isTel: false,
      isCode: false,
      isReady: false
    };
  },

  components: {
    ListCart: __WEBPACK_IMPORTED_MODULE_4__ListCart__["a" /* default */],
    VueTelInput: __WEBPACK_IMPORTED_MODULE_5_vue_tel_input___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['clearAllData', 'verifyPromoCode', 'clearDiscount', 'setTel', 'setIsloading', 'fetchPrinters']), {
    onInputTel: function onInputTel(_ref) {
      var number = _ref.number,
          isValid = _ref.isValid,
          country = _ref.country;

      this.phone = {
        number: number.replace(/ /g, ''),
        isValid: isValid,
        country: country
      };
    },
    clearPromotionCode: function clearPromotionCode() {
      this.promoCode = '';
      this.isCode = false;
    },
    clear: function clear() {
      var _this = this;

      this.$dialog.confirm({
        title: 'ลบสินค้าทุกชิ้นออกจากตระกร้า',
        message: 'คุณแน่ใจแล้วใช่ไหมที่จะ<span class="error-message">ลบสินค้าทุกชิ้น</span>ออกจากตระกร้า?',
        cancelText: 'ไม่ใช่',
        confirmText: 'ใช่',
        onConfirm: function onConfirm() {
          _this.clearAllData();
          _this.$router.push({ name: 'Home' });
        }
      });
    },
    verifyCode: function verifyCode() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var message, params, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.setIsloading(true);
                message = '';
                params = {
                  promoCode: _this2.promoCode.toUpperCase(),
                  tel: _this2.getTel,
                  getFullPrice: _this2.getFullPrice
                };
                _context.next = 5;
                return _this2.verifyPromoCode(params);

              case 5:
                res = _context.sent;

                if (res.data.success) {
                  message = '<center>Code <span class="success-message">' + res.data.promotion_code.code + '</span> can be use.</center>';
                  _this2.isCode = true;
                } else {
                  message = '<center><span class="error-message">' + res.data.error.message + '</center>';
                }
                _this2.setIsloading(false);
                _this2.$dialog.alert({
                  confirmText: 'ตกลง',
                  title: res.title,
                  message: message
                });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    setMemberTel: function setMemberTel() {
      var tel = this.tel.replace(/ /g, '');
      if (this.phone.isValid) {
        this.setTel(tel);
        this.isTel = true;
      } else {
        this.$dialog.alert({
          confirmText: 'ตกลง',
          title: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
          message: 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง'
        });
      }
    },
    confirm: function confirm() {
      this.$router.push({ name: 'Payment' });
    },
    changTel: function changTel() {
      this.isTel = false;
      this.phone = {};
      this.isCode = false;
      this.tel = '';
      this.promoCode = '';
      this.clearDiscount();
      this.setTel();
    },
    changCode: function changCode() {
      this.isCode = false;
      this.clearDiscount();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    netPrice: 'getNetPrice',
    discount: 'discount',
    amount: 'getItemsAmount',
    items: 'getItems',
    getTel: 'getTel',
    promotionCode: 'getPromotionCode',
    getFullPrice: 'getFullPrice',
    mainColor: 'mainColor'
  })),
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log(_this3);
              _context2.next = 3;
              return _this3.fetchPrinters();

            case 3:
              if (_this3.getTel !== '') {
                _this3.tel = _this3.getTel;
                _this3.isTel = true;
              }
              if (_this3.promotionCode.code && _this3.promotionCode.code !== '') {
                _this3.promoCode = _this3.promotionCode.code;
                _this3.isCode = true;
              } else {
                _this3.isCode = false;
                _this3.clearDiscount();
              }

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },

  watch: {
    amount: function amount(val) {
      if (val === 0) {
        this.$router.push({ name: 'Home' });
      }
    }
  }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  name: 'list-cart',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['addQuantity', 'removeItem']), {
    confirmCustomDelete: function confirmCustomDelete(item) {
      var _this = this;

      console.log(item);
      this.$dialog.confirm({
        title: 'ลบสินค้าออกจากตระกร้า',
        message: 'คุณแน่ใจแล้วใช่ไหมที่จะ<span class="error-message">ลบสินค้าชิ้นนี้</span>ออกจากตระกร้า?',
        cancelText: 'ไม่ใช่',
        confirmText: 'ใช่',
        onConfirm: function onConfirm() {
          _this.removeItem(item);
          _this.$emit('clearPromotionCode');
        }
      });
    }
  })
});

/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





var HttpRequest = function () {
  function HttpRequest(url) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, HttpRequest);

    this.axiosInstance = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
      baseURL: url,
      timeout: 120000
    });
    this.axiosInstance.interceptors.request.use(function (config) {
      // Do something before request is sent
      return config;
    }, function (error) {
      // Do something with request error
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
    });
    // Add a response interceptor
    // this.axiosInstance.interceptors.response.use(function (response) {
    //   // Do something with response data
    //   return response
    // }, function (error) {
    //   // Do something with response error
    //   if (error.response.status === 401) {
    //     window.location.href = process.env.SELLSUKI_LOGOUT_PORTAL
    //   }
    //   return Promise.reject(error)
    // })
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(HttpRequest, [{
    key: 'setHeader',
    value: function setHeader(header) {
      this.axiosInstance.defaults.headers.common = header;
      this.axiosInstance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    }
  }, {
    key: 'get',
    value: function get(methodName, data) {
      return this.axiosInstance.get(methodName, {
        params: data
      });
    }
  }, {
    key: 'create',
    value: function create(methodName, data, param) {
      return this.axiosInstance.post(methodName, data, {
        params: param
      });
    }
  }, {
    key: 'update',
    value: function update(methodName, data) {
      return this.axiosInstance.put(methodName, data);
    }
  }, {
    key: 'delete',
    value: function _delete(methodName, param, data) {
      return this.axiosInstance.delete(methodName, {
        params: param,
        data: data
      });
    }
  }, {
    key: 'request',
    value: function request(type, url, data) {
      var promise = null;
      switch (type) {
        case 'GET':
          promise = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: data });break;
        case 'POST':
          promise = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, data);break;
        case 'PUT':
          promise = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, data);break;
        case 'DELETE':
          promise = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url, data);break;
        default:
          promise = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, { params: data });break;
      }
      return promise;
    }
  }]);

  return HttpRequest;
}();

/* harmony default export */ __webpack_exports__["a"] = (HttpRequest);

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'payment',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    netPrice: 'getNetPrice',
    mainColor: 'mainColor'
  }))
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SelectPrinter__ = __webpack_require__(281);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkout-by-cash',
  components: {
    SelectPrinter: __WEBPACK_IMPORTED_MODULE_4__components_SelectPrinter__["a" /* default */]
  },
  data: function data() {
    return {
      receive: 0,
      activeModal: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setChange', 'setReceivedCash', 'calculatedChange', 'checkout', 'setIsloading', 'setPrintReceipt', 'fetchPrinters']), {
    finishCheckout: function finishCheckout(paymentType) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.change < 0)) {
                  _context.next = 4;
                  break;
                }

                _this.$dialog.alert({
                  title: 'เกิดข้อผิดพลาด',
                  confirmText: 'ตกลง',
                  message: 'เงินที่ได้รับน้อยกว่ามูลค้าสินค้า <br> กรุณาใส่จำนวนเงินที่ได้รับใหม่อีกครั้ง'
                });
                _context.next = 9;
                break;

              case 4:
                _this.setIsloading(true);
                _context.next = 7;
                return _this.checkout(paymentType);

              case 7:
                _this.setIsloading(false);
                _this.activeModal = true;

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    clear: function clear() {
      this.setChange(0);
      this.setReceivedCash(0);
      this.receive = 0;
    },
    addReceive: function addReceive(money) {
      this.receive = this.receive === '' ? money : parseInt(this.receive) + money;
      this.calculatedChange({ receive: this.receive, netPrice: this.netPrice });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    netPrice: 'getNetPrice',
    fullPrice: 'getFullPrice',
    change: 'getChange',
    receivedCash: 'getReceivedCash',
    mainColor: 'mainColor'
  })),
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.fetchPrinters();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectPrinter_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4350e843_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectPrinter_vue__ = __webpack_require__(459);
function injectStyle (ssrContext) {
  __webpack_require__(458)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4350e843"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectPrinter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4350e843_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectPrinter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'receipt',
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['clearAllData', 'setIsloading', 'printReceiptAction']), {
    finishPrint: function finishPrint(printerIP) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  printerIP: printerIP,
                  status: 'pending'
                };

                _this.setIsloading(true);
                _context.next = 4;
                return _this.printReceiptAction(params);

              case 4:
                _this.clearData();
                _this.setIsloading(false);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    clearData: function clearData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.clearAllData();
                _this2.$router.push({ name: 'Home' });

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    printers: 'getPrinters',
    billID: 'getBillID',
    mainColor: 'mainColor'
  }))
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SelectPrinter__ = __webpack_require__(281);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkout-by-cash',
  components: {
    SelectPrinter: __WEBPACK_IMPORTED_MODULE_4__components_SelectPrinter__["a" /* default */]
  },
  data: function data() {
    return {
      activeModal: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['checkout', 'setIsloading', 'fetchPrinters']), {
    finishCheckout: function finishCheckout(paymentType) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setIsloading(true);
                _context.next = 3;
                return _this.checkout(paymentType);

              case 3:
                _this.setIsloading(false);
                _this.activeModal = true;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    netPrice: 'getNetPrice',
    fullPrice: 'getFullPrice',
    mainColor: 'mainColor'
  })),
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.fetchPrinters();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_selectStore__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_helper_localStorage__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-info',
  data: function data() {
    return {
      sellsukiVersion: window.sellsukiVersion,
      activeModal: false,
      userInfo: {
        user: {
          id: '',
          first_name: '',
          last_name: '',
          username: '',
          branch_name: '',
          pos_id: ''
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    mainColor: 'mainColor'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    back: function back() {
      this.$router.push({ path: '/' });
    },
    logout: function logout() {
      var _this = this;

      this.$dialog.confirm({
        title: 'ยืนยันการออกจากระบบ',
        message: '<center>คุณต้องการออกจากระบบใช่หรือไม่ ?</center>',
        cancelText: 'ไม่ใช่',
        confirmText: 'ใช่',
        onConfirm: function onConfirm() {
          _this.setSellsukiAuth('');
          window.localStorage.removeItem('currentBranchPOS');
          window.location.href = "https://oms-login.akitahub.com/#/logout?target=seller-pos";
        }
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['setSellsukiAuth']), {
    changeBranch: function changeBranch() {
      this.activeModal = true;
    },
    getBranchNameDisplay: function getBranchNameDisplay() {
      this.userInfo.user.branch_name = Object(__WEBPACK_IMPORTED_MODULE_5__utils_helper_localStorage__["b" /* getBranchName */])();
      this.userInfo.user.pos_id = Object(__WEBPACK_IMPORTED_MODULE_5__utils_helper_localStorage__["d" /* getPOSID */])();
    }
  }),
  components: {
    selectStore: __WEBPACK_IMPORTED_MODULE_3__views_selectStore__["a" /* default */]
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Object(__WEBPACK_IMPORTED_MODULE_5__utils_helper_localStorage__["e" /* getSellsukiUser */])();

            case 2:
              _this2.userInfo = _context.sent;

              _this2.getBranchNameDisplay();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resources_report_provider__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resources_print_provider__ = __webpack_require__(253);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var reportProvider = new __WEBPACK_IMPORTED_MODULE_6__resources_report_provider__["a" /* default */]();

var printService = new __WEBPACK_IMPORTED_MODULE_7__resources_print_provider__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReportZ',
  data: function data() {
    return {
      maxDate: new Date(),
      selectedDate: new Date(),
      selectedPrinter: '',
      startPrice: '',
      givePrice: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])({
    printers: 'getPrinters',
    storeId: 'storeId',
    mainColor: 'mainColor'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['fetchPrinters', 'setReceiptData', 'setIsloading', 'triggerPrinter']), {
    back: function back() {
      this.$router.push({ path: '/user-info' });
    },
    print: function print() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formatSelectedDate, reportZ, currentBranchPOS, payload;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setIsloading(true);

                if (!_this.validateData()) {
                  _context.next = 5;
                  break;
                }

                _this.setIsloading(false);
                _this.$dialog.alert({
                  title: 'เกิดข้อผิดพลาด',
                  confirmText: 'ตกลง',
                  message: 'มีบางอย่างผิดพลาดกรุณากรอกข้อมูลให้ครบ'
                });
                return _context.abrupt('return');

              case 5:
                formatSelectedDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this.selectedDate).subtract(1, 'days').format('YYYY-MM-D');
                _context.next = 8;
                return reportProvider.getReportZ(formatSelectedDate);

              case 8:
                reportZ = _context.sent;
                currentBranchPOS = Object(__WEBPACK_IMPORTED_MODULE_3__utils_helper_localStorage__["c" /* getCurrentBranchPOS */])();
                payload = {
                  sumBillNet: parseFloat(reportZ.sum_bill_net),
                  sumBillDiscount: parseFloat(reportZ.sum_bill_discount),
                  startPrice: parseFloat(_this.startPrice),
                  givePrice: parseFloat(_this.givePrice),
                  countBill: parseInt(reportZ.count_bill),
                  firstBill: reportZ.first_bill[0] ? reportZ.first_bill[0] : null,
                  lastBill: reportZ.last_bill[0] ? reportZ.last_bill[0] : null,
                  displayTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('DD-MM-YYYY HH:mm'),
                  printTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('DD-MM-YYYY HH:mm'),
                  storeDisplayName: 'Gentlewoman',
                  payments: reportZ.payment.map(function (re) {
                    return {
                      total: parseFloat(re.total),
                      type: re.payment_channel === 'Cash' || re.payment_channel === 'cash' ? 'cash' : 'credit'
                    };
                  }),
                  print: {
                    message: '',
                    status: 'pending',
                    ip: _this.selectedPrinter
                  },
                  branchPos: {
                    branchId: parseInt(currentBranchPOS.branch_id),
                    name: currentBranchPOS.name,
                    posId: currentBranchPOS.pos_id,
                    taxId: 'TAX#0-1055-61034-56-1',
                    unitId: parseInt(currentBranchPOS.unit_id),
                    code: currentBranchPOS.warehouse
                  }
                };
                _context.prev = 11;
                _context.next = 14;
                return printService.printReportZ(payload);

              case 14:
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](11);

                console.log(_context.t0);
                alert('ไม่พบรายงานการขาย');

              case 20:
                _this.setIsloading(false);

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[11, 16]]);
      }))();
    },
    validateData: function validateData() {
      return this.selectedPrinter === '' || this.startPrice === '' || this.givePrice === '';
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.fetchPrinters();

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      PdogLoad: true
    };
  },

  name: 'PrepareLogin',
  props: ['storeId'],
  created: function created() {
    if (this.storeId) {
      this.$sellsuki_auth.initLocalStorage(this.storeId);
    } else {
      this.$sellsuki_auth.initLocalStorage(0);
    }
  }
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sellsuki_version_js__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sellsuki_version_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sellsuki_version_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_filter__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_buefy__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_main_css__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_buefy_lib_buefy_css__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_buefy_lib_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_buefy_lib_buefy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_begeta_css_begeta_min_css__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_begeta_css_begeta_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_begeta_css_begeta_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_perfect_scrollbar__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_oms_auth__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_oms_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_oms_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_svg_filler__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_svg_filler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_svg_filler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_tel_input_dist_vue_tel_input_css__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_tel_input_dist_vue_tel_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_tel_input_dist_vue_tel_input_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














// import VueTelInput from 'vue-tel-input'

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_buefy___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('svg-filler', __WEBPACK_IMPORTED_MODULE_12_vue_svg_filler___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('VuePerfectScrollbar', __WEBPACK_IMPORTED_MODULE_10_vue_perfect_scrollbar___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_oms_auth___default.a, {
  portal: "https://oms-login.akitahub.com/#/choosestore?target=seller-pos",
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]
});
// Vue.use(VueTelInput)

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  filter: __WEBPACK_IMPORTED_MODULE_4__utils_filter__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

window.sellsukiVersion = '761eb6f'


/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ded96c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(342);
function injectStyle (ssrContext) {
  __webpack_require__(293)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ded96c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 293:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 338:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-cl-white body-box dp-flex jtf-ct-center al-it-center f-drt-column"},[_c('div',{staticClass:"w-100pct bg-cl-light cl-black f-s-22px f-w-bold pd-18px t-al-center"},[_vm._v("\n    ตั้งค่าสาขา\n  ")]),_vm._v(" "),_c('div',{staticClass:"w-80pct mg-vtc-10px"},[_c('b-select',{attrs:{"expanded":""},model:{value:(_vm.selectBranch),callback:function ($$v) {_vm.selectBranch=$$v},expression:"selectBranch"}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("เลือกสาขา")]),_vm._v(" "),_vm._l((_vm.branchs),function(branch,index){return _c('option',{key:index,domProps:{"value":branch}},[_vm._v("\n        "+_vm._s(branch.name)+"\n      ")])})],2)],1),_vm._v(" "),(_vm.selectBranch !== '')?_c('div',{staticClass:"w-80pct mg-vtc-10px"},[_c('b-select',{attrs:{"expanded":""},model:{value:(_vm.selectPOS),callback:function ($$v) {_vm.selectPOS=$$v},expression:"selectPOS"}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("POS ID")]),_vm._v(" "),_vm._l((_vm.selectBranch.posID),function(pos,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v("\n        "+_vm._s(pos)+"( "+_vm._s(_vm.selectBranch.posWarehouseDisplayName[index])+" )\n      ")])})],2)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-80pct mg-vtc-10px pd-vtc-10px cl-white cs-pointer bd-rd-4px f-w-bold t-al-center",style:(("background-color: " + _vm.mainColor + ";"))},[_c('div',{on:{"click":function($event){_vm.confirmSelect()}}},[_vm._v("\n      ตกลง\n    ")])]),_vm._v(" "),(_vm.cancelBtn)?_c('div',{staticClass:"w-80pct mg-vtc-10px pd-vtc-10px bg-cl-light cs-pointer bd-rd-4px f-w-bold"},[_c('div',{on:{"click":function($event){_vm.cancel()}}},[_vm._v("\n      ยกเลิก\n    ")])]):_c('div',{staticClass:"w-80pct mg-vtc-10px pd-vtc-10px bg-cl-light cs-pointer bd-rd-4px f-w-bold t-al-center"},[_c('div',{on:{"click":function($event){_vm.logout()}}},[_vm._v("\n      ออกจากระบบ\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isUpToDate)?_c('div',[_c('b-loading',{attrs:{"is-full-page":true,"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('b-modal',{attrs:{"active":_vm.activeModal,"canCancel":[]},on:{"update:active":function($event){_vm.activeModal=$event}}},[_c('selectStore',{attrs:{"cancelBtn":false}})],1),_vm._v(" "),_c('main',[_c('router-view')],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persist__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_cart__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_payment__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_print__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_product__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_sellsukiData__ = __webpack_require__(387);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_2_vuex_persist__["a" /* default */]({
  key: 'store',
  storage: localStorage
});

var store = function store() {
  return new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
      cart: __WEBPACK_IMPORTED_MODULE_3__modules_cart__["a" /* default */],
      payment: __WEBPACK_IMPORTED_MODULE_4__modules_payment__["a" /* default */],
      print: __WEBPACK_IMPORTED_MODULE_5__modules_print__["a" /* default */],
      product: __WEBPACK_IMPORTED_MODULE_6__modules_product__["a" /* default */],
      sellsukiData: __WEBPACK_IMPORTED_MODULE_7__modules_sellsukiData__["a" /* default */]
    },
    plugins: [vuexLocalStorage.plugin]
  });
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_promotion_provider__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_helper_localStorage__ = __webpack_require__(6);




var promotionProvider = new __WEBPACK_IMPORTED_MODULE_2__resources_promotion_provider__["a" /* default */]();

var state = {
  items: [],
  customerTel: '',
  discount: 0,
  promotionCode: {}
};

var actions = {
  verifyPromoCode: function verifyPromoCode(_ref, payload) {
    var _this = this;

    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        state = _ref.state;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return promotionProvider.verifyPromotionCode({
                code: payload.promoCode,
                memberTel: payload.tel,
                items: state.items,
                warehouse: {
                  id: parseInt(Object(__WEBPACK_IMPORTED_MODULE_3__utils_helper_localStorage__["c" /* getCurrentBranchPOS */])().branch_id),
                  name: Object(__WEBPACK_IMPORTED_MODULE_3__utils_helper_localStorage__["c" /* getCurrentBranchPOS */])().warehouse_display_name,
                  code: Object(__WEBPACK_IMPORTED_MODULE_3__utils_helper_localStorage__["c" /* getCurrentBranchPOS */])().warehouse
                }
              });

            case 2:
              res = _context.sent;

              if (res.data.success) {
                commit('SET_PROMOTION_CODE', res.data.promotion_code);
                commit('SET_DISCOUNT', res.data.discount);
              } else {
                dispatch('clearDiscount');
              }
              return _context.abrupt('return', res);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  addItem: function addItem(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!payload) {
                _context2.next = 4;
                break;
              }

              commit('ADD_ITEM', payload);
              commit('CLEAR_DISCOUNT');
              return _context2.abrupt('return', true);

            case 4:
              return _context2.abrupt('return', false);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  removeItem: function removeItem(_ref3, payload) {
    var commit = _ref3.commit;

    commit('REMOVE_ITEM', payload);
    commit('CLEAR_DISCOUNT');
  },
  setTel: function setTel(_ref4, payload) {
    var commit = _ref4.commit;

    commit('SET_TEL', payload);
  },
  clearAllData: function clearAllData(_ref5) {
    var dispatch = _ref5.dispatch,
        commit = _ref5.commit;

    this.dispatch('clearMoney');
    this.dispatch('initState');
    dispatch('clearDiscount');
    commit('CLEAR_ITEM_IN_CART');
    dispatch('setTel');
  },
  clearDiscount: function clearDiscount(_ref6) {
    var commit = _ref6.commit;

    commit('CLEAR_DISCOUNT');
  }
};

var mutations = {
  ADD_ITEM: function ADD_ITEM(state, payload) {
    state.items.push(payload);
  },
  SET_PROMOTION_CODE: function SET_PROMOTION_CODE(state, payload) {
    state.promotionCode = payload;
  },
  SET_DISCOUNT: function SET_DISCOUNT(state, payload) {
    state.discount = payload;
  },
  CLEAR_ITEM_IN_CART: function CLEAR_ITEM_IN_CART(state) {
    state.items = [];
  },
  REMOVE_ITEM: function REMOVE_ITEM(state, payload) {
    var index = state.items.findIndex(function (item) {
      return item.id === payload.id;
    });
    state.items.splice(index, 1);
  },
  CLEAR_DISCOUNT: function CLEAR_DISCOUNT(state) {
    state.discount = 0;
    state.promotionCode = {};
  },
  SET_TEL: function SET_TEL(state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    state.customerTel = payload;
  }
};

var getters = {
  getItems: function getItems(state) {
    return state.items;
  },
  getFullPrice: function getFullPrice(state) {
    return state.items.reduce(function (sum, item) {
      return sum + parseInt(item.price);
    }, 0);
  },
  getNetPrice: function getNetPrice(state) {
    var netPrice = state.items.reduce(function (sum, item) {
      return sum + parseInt(item.price);
    }, 0) - state.discount;
    return netPrice <= 0 ? 0 : netPrice;
  },
  getItemsAmount: function getItemsAmount(state) {
    return state.items.reduce(function (sum, item) {
      return sum + item.quantity;
    }, 0);
  },
  getDiscount: function getDiscount(state) {
    return state.discount;
  },
  discount: function discount(state) {
    return state.discount;
  },
  getPromotionCode: function getPromotionCode(state) {
    return state.promotionCode;
  },
  getTel: function getTel(state) {
    return state.customerTel;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http_request__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js__);











var PromotionProvider = function (_HttpRequest) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(PromotionProvider, _HttpRequest);

  function PromotionProvider() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PromotionProvider);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PromotionProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PromotionProvider)).call(this, '' + "https://production-api-dclzrwc4na-an.a.run.app"));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PromotionProvider, [{
    key: 'verifyPromotionCode',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(payload) {
        var validatePromotionCodePayload, newStore, _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                validatePromotionCodePayload = {
                  code: payload.code,
                  member: {
                    tel: payload.memberTel
                  },
                  items: payload.items.map(function (item) {
                    return {
                      sku_id: parseInt(item.id),
                      code: item.code,
                      name: item.name,
                      amount: parseInt(item.amount),
                      option: '',
                      price: parseFloat(item.price),
                      full_price: parseFloat(item.fullPrice),
                      productId: parseInt(item.productId),
                      brand: {
                        id: 2,
                        name: 'a'
                      },
                      warehouse: {
                        id: payload.warehouse.id,
                        name: payload.warehouse.name,
                        code: payload.warehouse.code
                      },
                      categories: item.categories,
                      tags: item.tags
                    };
                  }),
                  channel: 'pos'
                };
                _context.prev = 1;
                newStore = __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] ? __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] : '000000000';
                _context.next = 5;
                return this.create('/public/' + newStore.id + '/promotion-codes/validate', validatePromotionCodePayload);

              case 5:
                _ref2 = _context.sent;
                data = _ref2.data;
                return _context.abrupt('return', data);

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](1);
                return _context.abrupt('return', {
                  data: { success: false,
                    error: {
                      message: _context.t0.response ? _context.t0.response.data.message : 'Server error or Incorect store.'
                    }
                  }
                });

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 10]]);
      }));

      function verifyPromotionCode(_x) {
        return _ref.apply(this, arguments);
      }

      return verifyPromotionCode;
    }()
  }]);

  return PromotionProvider;
}(__WEBPACK_IMPORTED_MODULE_7__http_request__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PromotionProvider);

/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_modules_payment__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_order_provider__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resources_member_order_history__ = __webpack_require__(378);







var orderProvider = new __WEBPACK_IMPORTED_MODULE_5__resources_order_provider__["a" /* default */]();
var memberOrderProvider = new __WEBPACK_IMPORTED_MODULE_6__resources_member_order_history__["a" /* default */]();

var state = {
  type: '',
  change: '',
  receivedMoney: {
    receivedCash: '',
    receivedCard: ''
  },
  memberOrderHistory: {},
  total: '',
  order: {},
  time: ''
};

var actions = {
  setOrder: function setOrder(_ref, payload) {
    var _this = this;

    var commit = _ref.commit,
        getters = _ref.getters,
        state = _ref.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var params, promoCode, cashier, order, _ref2, data;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log(payload);
              commit('SET_TOTAL');
              params = Object(__WEBPACK_IMPORTED_MODULE_3__utils_modules_payment__["a" /* initDataSetOrder */])(payload, state, getters.getTel, getters.billExpire);
              promoCode = getters.getPromotionCode;
              cashier = Object(__WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__["j" /* getUserCashier */])();
              _context.next = 7;
              return orderProvider.posCompleteCart(params, promoCode, getters.getTel);

            case 7:
              order = _context.sent;
              _context.next = 10;
              return memberOrderProvider.createOrderHistory({
                order: order,
                tel: getters.getTel,
                items: getters.getItems,
                promotionCode: getters.getPromotionCode,
                cashier: cashier
              });

            case 10:
              _ref2 = _context.sent;
              data = _ref2.data;

              console.log(data);
              commit('SET_ORDER', order);
              commit('SET_MEMBER_ORDER_HISTORY', data);

              return _context.abrupt('return', data);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  calculatedChange: function calculatedChange(_ref3, payload) {
    var commit = _ref3.commit;

    commit('CALCULATED_CHANGE', payload);
  },
  setChange: function setChange(_ref4, payload) {
    var commit = _ref4.commit;

    commit('SET_CHANGE', payload);
  },
  setReceivedCash: function setReceivedCash(_ref5, payload) {
    var commit = _ref5.commit;

    commit('SET_RECEIVE_CASH', payload);
  },
  clearMoney: function clearMoney(_ref6) {
    var commit = _ref6.commit;

    commit('CLEAR_MONEY');
  },
  checkout: function checkout(_ref7, channel) {
    var _this2 = this;

    var dispatch = _ref7.dispatch,
        getters = _ref7.getters,
        commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var paymentChannels, paymentChannelIndex, payPal;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (channel === 'Credit') {
                commit('SET_RECEIVED_CARD', getters.getNetPrice);
                commit('SET_RECEIVE_CASH', 0);
                commit('SET_CHANGE', 0);
              } else {
                commit('SET_RECEIVED_CARD', 0);
              }
              paymentChannels = getters.paymentChannel;
              paymentChannelIndex = paymentChannels.findIndex(function (type) {
                return type.payment_name === channel;
              });
              payPal = paymentChannels.find(function (type) {
                return type.payment_name === 'Paypal';
              });

              if (!(paymentChannelIndex === -1)) {
                _context2.next = 9;
                break;
              }

              _context2.next = 7;
              return commit('SET_TYPE', payPal);

            case 7:
              _context2.next = 11;
              break;

            case 9:
              _context2.next = 11;
              return commit('SET_TYPE', paymentChannels[paymentChannelIndex]);

            case 11:
              _context2.next = 13;
              return commit('SET_TIME', new Date());

            case 13:
              _context2.next = 15;
              return dispatch('setOrder', { items: getters.getItems, price: getters.getNetPrice });

            case 15:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};

var mutations = {
  SET_TYPE: function SET_TYPE(state, payload) {
    state.type = payload;
  },
  SET_ORDER: function SET_ORDER(state, payload) {
    state.order = payload;
  },
  CALCULATED_CHANGE: function CALCULATED_CHANGE(state, payload) {
    state.receivedMoney.receivedCash = payload.receive;
    state.change = state.receivedMoney.receivedCash - payload.netPrice;
  },
  SET_MEMBER_ORDER_HISTORY: function SET_MEMBER_ORDER_HISTORY(state, payload) {
    state.memberOrderHistory = payload;
  },
  SET_CHANGE: function SET_CHANGE(state, payload) {
    state.change = payload;
  },
  SET_RECEIVED_CARD: function SET_RECEIVED_CARD(state, payload) {
    state.receivedMoney.receivedCard = payload;
  },
  SET_RECEIVE_CASH: function SET_RECEIVE_CASH(state, payload) {
    state.receivedMoney.receivedCash = payload;
  },
  CLEAR_MONEY: function CLEAR_MONEY(state) {
    state.receivedMoney.receivedCard = 0;
    state.receivedMoney.receivedCash = 0;
    state.change = 0;
  },
  SET_TIME: function SET_TIME(state, payload) {
    state.time = payload;
  },
  SET_TOTAL: function SET_TOTAL(state) {
    state.total = state.receivedMoney.receivedCash + state.receivedMoney.receivedCard;
  }
};

var getters = {
  getChange: function getChange(state) {
    return state.change;
  },
  getReceivedCash: function getReceivedCash(state) {
    return state.receivedMoney.receivedCash;
  },
  getMemberOrderHistory: function getMemberOrderHistory(state) {
    return state.memberOrderHistory;
  },
  getReceivedCard: function getReceivedCard(state) {
    return state.receivedMoney.receivedCard;
  },
  getOrder: function getOrder(state) {
    return state.order;
  },
  getBillID: function getBillID(state) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.order).length === 0 ? '' : state.order.bill.id;
  },
  getTime: function getTime(state) {
    return state.time;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initDataSetOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);


var initDataSetOrder = function initDataSetOrder(payload, state) {
  var tel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var billExpire = arguments[3];

  var cartList = payload.items;
  var price = payload.price;
  var expireDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(parseInt(billExpire), 'd').format('X');
  var skus = transformCartList(cartList);
  var pendingData = createPendingData(state.type, price, tel);
  var paymentLog = createPaymentLog(state.type, state.total, state.change);
  var discount = calDebt(cartList) - price;
  var data = {
    skus: skus,
    debts: [{
      dead_line_date: '',
      debt_balance: price,
      pay_order: 1
    }],
    shipping_type: 'POS',
    discount: discount,
    shipcost: 0,
    bill_expire: parseInt(expireDate),
    pending_data: pendingData,
    pay_order: 1,
    prepare_date: '',
    customer_id: null,
    coupon_id: '',
    unit_id: Object(__WEBPACK_IMPORTED_MODULE_0__utils_helper_localStorage__["h" /* getUnitID */])(),
    store_pos_branch_id: Object(__WEBPACK_IMPORTED_MODULE_0__utils_helper_localStorage__["a" /* getBranchID */])(),
    payment_log: paymentLog,
    promotion_discount: 0,
    promotions: {}
  };

  var result = {
    data: data,
    price: price
  };

  return result;
};

function calDebt(cartList) {
  var total = cartList.reduce(function (sum, item) {
    return sum + parseInt(item.price);
  }, 0);
  return total;
}

function createPendingData(paymentType, price, tel) {
  var pendingData = {
    customer_name: '',
    customer_address: '',
    customer_postcode: '',
    customer_tel: tel,
    customer_email: '',
    payments: [{
      bill_debt_pay_order: 1,
      date: new Date(),
      amount: parseFloat(price).toFixed(2),
      store_payment_channel_id: paymentType.id,
      attached_slip: '',
      cache_payment_channel_name: paymentType.payment_name,
      cache_payment_channel_id: paymentType.payment_channel_id,
      cache_payment_channel_logo: paymentType.logo,
      cache_payment_channel_type: paymentType.payment_name.toLowerCase(),
      cache_store_payment_channel_credential: '{}'
    }]
  };
  return pendingData;
}

function createPaymentLog(paymentType, receivedMoney, change) {
  var paymentLog = {
    recivePayment: parseFloat(receivedMoney).toFixed(2),
    changePayment: parseFloat(change).toFixed(2),
    payments: [{
      id: paymentType.id,
      name: paymentType.payment_name,
      logo: paymentType.logo,
      payment_channel_id: paymentType.payment_channel_id,
      payment_channel_name: paymentType.payment_name,
      payment_channel_type: paymentType.payment_name.toLowerCase(),
      payment_channel_logo: paymentType.logo,
      credential: '{}',
      value: '99'
    }]
  };
  return paymentLog;
}

function transformCartList(cartList) {
  var skus = [];
  cartList.map(function (item) {
    skus.push({
      product_id: item.productId,
      brand_name: '',
      code: '',
      id: item.id,
      price: item.price,
      stock_lot: item.remain,
      skuStatus: '1',
      name: item.name,
      description: '',
      variants: ['SKU', '', ''],
      concat_sku_options: item.optionPOSCompleteCart,
      concatSkuOptions: [],
      sku_src: item.image,
      options: 'default  ',
      warehouse: Object(__WEBPACK_IMPORTED_MODULE_0__utils_helper_localStorage__["k" /* getWerehouse */])(),
      amount: 1,
      discount: {
        type: 'percentageOff',
        value: 10
      },
      fullPrice: item.price,
      isManualDiscount: false
    });
  });
  return skus;
}



/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 117,
	"./af.js": 117,
	"./ar": 118,
	"./ar-dz": 119,
	"./ar-dz.js": 119,
	"./ar-kw": 120,
	"./ar-kw.js": 120,
	"./ar-ly": 121,
	"./ar-ly.js": 121,
	"./ar-ma": 122,
	"./ar-ma.js": 122,
	"./ar-sa": 123,
	"./ar-sa.js": 123,
	"./ar-tn": 124,
	"./ar-tn.js": 124,
	"./ar.js": 118,
	"./az": 125,
	"./az.js": 125,
	"./be": 126,
	"./be.js": 126,
	"./bg": 127,
	"./bg.js": 127,
	"./bm": 128,
	"./bm.js": 128,
	"./bn": 129,
	"./bn-bd": 130,
	"./bn-bd.js": 130,
	"./bn.js": 129,
	"./bo": 131,
	"./bo.js": 131,
	"./br": 132,
	"./br.js": 132,
	"./bs": 133,
	"./bs.js": 133,
	"./ca": 134,
	"./ca.js": 134,
	"./cs": 135,
	"./cs.js": 135,
	"./cv": 136,
	"./cv.js": 136,
	"./cy": 137,
	"./cy.js": 137,
	"./da": 138,
	"./da.js": 138,
	"./de": 139,
	"./de-at": 140,
	"./de-at.js": 140,
	"./de-ch": 141,
	"./de-ch.js": 141,
	"./de.js": 139,
	"./dv": 142,
	"./dv.js": 142,
	"./el": 143,
	"./el.js": 143,
	"./en-au": 144,
	"./en-au.js": 144,
	"./en-ca": 145,
	"./en-ca.js": 145,
	"./en-gb": 146,
	"./en-gb.js": 146,
	"./en-ie": 147,
	"./en-ie.js": 147,
	"./en-il": 148,
	"./en-il.js": 148,
	"./en-in": 149,
	"./en-in.js": 149,
	"./en-nz": 150,
	"./en-nz.js": 150,
	"./en-sg": 151,
	"./en-sg.js": 151,
	"./eo": 152,
	"./eo.js": 152,
	"./es": 153,
	"./es-do": 154,
	"./es-do.js": 154,
	"./es-mx": 155,
	"./es-mx.js": 155,
	"./es-us": 156,
	"./es-us.js": 156,
	"./es.js": 153,
	"./et": 157,
	"./et.js": 157,
	"./eu": 158,
	"./eu.js": 158,
	"./fa": 159,
	"./fa.js": 159,
	"./fi": 160,
	"./fi.js": 160,
	"./fil": 161,
	"./fil.js": 161,
	"./fo": 162,
	"./fo.js": 162,
	"./fr": 163,
	"./fr-ca": 164,
	"./fr-ca.js": 164,
	"./fr-ch": 165,
	"./fr-ch.js": 165,
	"./fr.js": 163,
	"./fy": 166,
	"./fy.js": 166,
	"./ga": 167,
	"./ga.js": 167,
	"./gd": 168,
	"./gd.js": 168,
	"./gl": 169,
	"./gl.js": 169,
	"./gom-deva": 170,
	"./gom-deva.js": 170,
	"./gom-latn": 171,
	"./gom-latn.js": 171,
	"./gu": 172,
	"./gu.js": 172,
	"./he": 173,
	"./he.js": 173,
	"./hi": 174,
	"./hi.js": 174,
	"./hr": 175,
	"./hr.js": 175,
	"./hu": 176,
	"./hu.js": 176,
	"./hy-am": 177,
	"./hy-am.js": 177,
	"./id": 178,
	"./id.js": 178,
	"./is": 179,
	"./is.js": 179,
	"./it": 180,
	"./it-ch": 181,
	"./it-ch.js": 181,
	"./it.js": 180,
	"./ja": 182,
	"./ja.js": 182,
	"./jv": 183,
	"./jv.js": 183,
	"./ka": 184,
	"./ka.js": 184,
	"./kk": 185,
	"./kk.js": 185,
	"./km": 186,
	"./km.js": 186,
	"./kn": 187,
	"./kn.js": 187,
	"./ko": 188,
	"./ko.js": 188,
	"./ku": 189,
	"./ku.js": 189,
	"./ky": 190,
	"./ky.js": 190,
	"./lb": 191,
	"./lb.js": 191,
	"./lo": 192,
	"./lo.js": 192,
	"./lt": 193,
	"./lt.js": 193,
	"./lv": 194,
	"./lv.js": 194,
	"./me": 195,
	"./me.js": 195,
	"./mi": 196,
	"./mi.js": 196,
	"./mk": 197,
	"./mk.js": 197,
	"./ml": 198,
	"./ml.js": 198,
	"./mn": 199,
	"./mn.js": 199,
	"./mr": 200,
	"./mr.js": 200,
	"./ms": 201,
	"./ms-my": 202,
	"./ms-my.js": 202,
	"./ms.js": 201,
	"./mt": 203,
	"./mt.js": 203,
	"./my": 204,
	"./my.js": 204,
	"./nb": 205,
	"./nb.js": 205,
	"./ne": 206,
	"./ne.js": 206,
	"./nl": 207,
	"./nl-be": 208,
	"./nl-be.js": 208,
	"./nl.js": 207,
	"./nn": 209,
	"./nn.js": 209,
	"./oc-lnc": 210,
	"./oc-lnc.js": 210,
	"./pa-in": 211,
	"./pa-in.js": 211,
	"./pl": 212,
	"./pl.js": 212,
	"./pt": 213,
	"./pt-br": 214,
	"./pt-br.js": 214,
	"./pt.js": 213,
	"./ro": 215,
	"./ro.js": 215,
	"./ru": 216,
	"./ru.js": 216,
	"./sd": 217,
	"./sd.js": 217,
	"./se": 218,
	"./se.js": 218,
	"./si": 219,
	"./si.js": 219,
	"./sk": 220,
	"./sk.js": 220,
	"./sl": 221,
	"./sl.js": 221,
	"./sq": 222,
	"./sq.js": 222,
	"./sr": 223,
	"./sr-cyrl": 224,
	"./sr-cyrl.js": 224,
	"./sr.js": 223,
	"./ss": 225,
	"./ss.js": 225,
	"./sv": 226,
	"./sv.js": 226,
	"./sw": 227,
	"./sw.js": 227,
	"./ta": 228,
	"./ta.js": 228,
	"./te": 229,
	"./te.js": 229,
	"./tet": 230,
	"./tet.js": 230,
	"./tg": 231,
	"./tg.js": 231,
	"./th": 232,
	"./th.js": 232,
	"./tk": 233,
	"./tk.js": 233,
	"./tl-ph": 234,
	"./tl-ph.js": 234,
	"./tlh": 235,
	"./tlh.js": 235,
	"./tr": 236,
	"./tr.js": 236,
	"./tzl": 237,
	"./tzl.js": 237,
	"./tzm": 238,
	"./tzm-latn": 239,
	"./tzm-latn.js": 239,
	"./tzm.js": 238,
	"./ug-cn": 240,
	"./ug-cn.js": 240,
	"./uk": 241,
	"./uk.js": 241,
	"./ur": 242,
	"./ur.js": 242,
	"./uz": 243,
	"./uz-latn": 244,
	"./uz-latn.js": 244,
	"./uz.js": 243,
	"./vi": 245,
	"./vi.js": 245,
	"./x-pseudo": 246,
	"./x-pseudo.js": 246,
	"./yo": 247,
	"./yo.js": 247,
	"./zh-cn": 248,
	"./zh-cn.js": 248,
	"./zh-hk": 249,
	"./zh-hk.js": 249,
	"./zh-mo": 250,
	"./zh-mo.js": 250,
	"./zh-tw": 251,
	"./zh-tw.js": 251
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 377;

/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http_request__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js__);











var PromotionProvider = function (_HttpRequest) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(PromotionProvider, _HttpRequest);

  function PromotionProvider() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PromotionProvider);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PromotionProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PromotionProvider)).call(this, '' + "https://production-api-dclzrwc4na-an.a.run.app"));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PromotionProvider, [{
    key: 'createOrderHistory',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(payload) {
        var omsBranch, memberOrderHistoryPayload, newStore, _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                omsBranch = Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["c" /* getCurrentBranchPOS */])();
                memberOrderHistoryPayload = {
                  order: {
                    shipping_type: payload.order.bill.cache_shipping_type,
                    create_time: payload.order.bill.create_time,
                    currency: {
                      id: 1,
                      name: 'THB'
                    },
                    current_state: 'paid',
                    address: '',
                    country: '',
                    district: '',
                    customer_email: '',
                    customer_name: '',
                    postcode: '',
                    province: '',
                    states: '',
                    contact_no: payload.tel,
                    customer_tel: payload.tel,
                    discount: parseFloat(payload.order.bill.discount),
                    expire: payload.order.bill.expire,
                    id: payload.order.bill.id,
                    net: parseFloat(payload.order.bill.net),
                    note: '',
                    ship_cost: 0,
                    channel_type: 'pos',
                    url: payload.order.bill.url
                  },
                  order_items: payload.items.map(function (item) {
                    var variant1 = item.variant1.toLowerCase();
                    var variant2 = item.variant2.toLowerCase();
                    var color = '';
                    var size = '';
                    if (variant1 === 'color' || variant1 === 'colour') {
                      color = item.option1;
                    } else if (variant2 === 'color' || variant2 === 'colour') {
                      color = item.option2;
                    }

                    if (variant1 === 'size') {
                      size = item.option1;
                    } else if (variant2 === 'size') {
                      size = item.option2;
                    }

                    return {
                      skuId: parseInt(item.id),
                      code: item.code,
                      name: item.name,
                      amount: parseInt(item.amount),
                      color: color,
                      size: 'International:' + size,
                      option: '',
                      description: '',
                      price: parseFloat(item.price),
                      full_price: parseFloat(item.fullPrice),
                      productId: parseInt(item.productId),
                      skuImages: [item.image],
                      photo_urls: [item.image],
                      isOnWeb: true,
                      brand: {
                        id: 2,
                        name: 'a'
                      },
                      warehouse: {
                        id: omsBranch.branch_id,
                        name: omsBranch.warehouse_display_name,
                        code: omsBranch.warehouse
                      },
                      categories: item.categories,
                      tags: item.tags
                    };
                  }),
                  branch: {
                    id: omsBranch.branch_id,
                    name: omsBranch.warehouse_display_name,
                    code: omsBranch.warehouse
                  },
                  cashier: payload.cashier,
                  promotion_code: payload.promotionCode,
                  channel: 'pos'
                };
                _context.prev = 2;
                newStore = __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] ? __WEBPACK_IMPORTED_MODULE_9__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["g" /* getStoreId */])()] : '000000000';
                _context.next = 6;
                return this.create('/public/' + newStore.id + '/members/order-history', memberOrderHistoryPayload);

              case 6:
                _ref2 = _context.sent;
                data = _ref2.data;
                return _context.abrupt('return', data);

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](2);

                console.log(_context.t0);
                return _context.abrupt('return', { success: false });

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 11]]);
      }));

      function createOrderHistory(_x) {
        return _ref.apply(this, arguments);
      }

      return createOrderHistory;
    }()
  }]);

  return PromotionProvider;
}(__WEBPACK_IMPORTED_MODULE_7__http_request__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PromotionProvider);

/***/ }),

/***/ 379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resources_print_provider__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_new_member_store_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_new_member_store_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config_new_member_store_js__);








var printService = new __WEBPACK_IMPORTED_MODULE_5__resources_print_provider__["a" /* default */]();

var state = {
  printer: []
};
var actions = {
  fetchPrinters: function fetchPrinters(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var branchID, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              branchID = Object(__WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__["a" /* getBranchID */])();
              _context.next = 3;
              return printService.getPrinters(branchID);

            case 3:
              res = _context.sent;

              commit('SET_PRINTER', res.data);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  printReceiptAction: function printReceiptAction(_ref2, payload) {
    var _this2 = this;

    var getters = _ref2.getters;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var user, currentBranchPos, newStore, receiptData;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              user = Object(__WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__["i" /* getUser */])();
              currentBranchPos = Object(__WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__["c" /* getCurrentBranchPOS */])();
              newStore = __WEBPACK_IMPORTED_MODULE_6__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__["g" /* getStoreId */])()] ? __WEBPACK_IMPORTED_MODULE_6__config_new_member_store_js___default.a[Object(__WEBPACK_IMPORTED_MODULE_4__utils_helper_localStorage__["g" /* getStoreId */])()] : '000000000';
              receiptData = {
                billId: getters.getOrder.bill.id,
                branchPos: {
                  branchId: parseInt(currentBranchPos.branch_id),
                  name: currentBranchPos.name,
                  posId: currentBranchPos.pos_id,
                  taxId: 'TAX#0-1055-61034-56-1',
                  unitId: parseInt(currentBranchPos.unit_id),
                  code: currentBranchPos.warehouse
                },
                payment: {
                  type: getters.getReceivedCard === 0 ? 'cash' : 'credit',
                  receivedCash: parseFloat(getters.getReceivedCash),
                  receivedCredit: parseFloat(getters.getReceivedCard),
                  change: parseFloat(getters.getChange)
                },
                items: getters.getItems.map(function (item) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
                    fullPrice: parseFloat(item.fullPrice),
                    price: parseFloat(item.price)
                  });
                }),
                discount: parseFloat(getters.discount),
                print: {
                  message: '',
                  status: 'pending',
                  ip: payload.printerIP
                },
                fullPrice: parseFloat(getters.getFullPrice),
                price: getters.getNetPrice,
                cashier: {
                  id: parseInt(user.id),
                  first_name: user.first_name,
                  last_name: user.last_name
                },
                displayTime: __WEBPACK_IMPORTED_MODULE_3_moment___default()(getters.getTime).format('DD-MM-YYYY HH:mm'),
                member: getters.getMemberOrderHistory.data ? getters.getMemberOrderHistory.data.member : {},
                storeDisplayName: newStore.name,
                storeLogo: 'https://gentlewoman-management.s3-ap-southeast-1.amazonaws.com/receipt-image/gw-logo-shop.png'
              };

              if (payload.printerIP === 'no print') {
                receiptData.print.status = 'no_print';
              }
              _context2.next = 7;
              return printService.printReceipt(receiptData);

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};

var mutations = {
  SET_PRINTER: function SET_PRINTER(state, payload) {
    state.printer = payload;
  }
};

var getters = {
  getPrinters: function getPrinters(state) {
    return state.printer;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
});

/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_product_provider__ = __webpack_require__(386);




var productProvider = new __WEBPACK_IMPORTED_MODULE_3__resources_product_provider__["a" /* default */]();

var state = {
  products: [],
  searchKey: '',
  productsNumber: 0,
  isLoading: false
};

var actions = {
  initState: function initState(_ref) {
    var commit = _ref.commit;

    commit('INIT_STATE');
  },
  setSearchKey: function setSearchKey(_ref2, payload) {
    var _this = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return productProvider.getProduct(payload);

            case 2:
              data = _context.sent;

              if (!data.productsNumber) {
                _context.next = 9;
                break;
              }

              commit('SET_SEARCH_KEY', payload);
              commit('SET_PRODUCTS', data);
              return _context.abrupt('return', true);

            case 9:
              commit('INIT_STATE');
              return _context.abrupt('return', false);

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  loadProductMore: function loadProductMore(_ref3, page) {
    var _this2 = this;

    var commit = _ref3.commit,
        state = _ref3.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return productProvider.getProduct(state.searchKey, page);

            case 2:
              data = _context2.sent;

              commit('ADD_PRODUCTS', data);

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  setIsloading: function setIsloading(_ref4, payload) {
    var commit = _ref4.commit;

    commit('SET_IS_LOADING', payload);
  }
};

var mutations = {
  INIT_STATE: function INIT_STATE(state) {
    state.products = [];
    state.searchKey = '';
    state.productsNumber = 0;
    state.isLoading = false;
  },
  SET_PRODUCTS: function SET_PRODUCTS(state, payload) {
    state.productsNumber = payload.productsNumber;
    if (payload.products) {
      state.products = payload.products;
    }
  },
  ADD_PRODUCTS: function ADD_PRODUCTS(state, payload) {
    state.productsNumber += payload.productsNumber;
    if (payload.products) {
      var _state$products;

      (_state$products = state.products).push.apply(_state$products, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(payload.products));
    }
  },
  SET_SEARCH_KEY: function SET_SEARCH_KEY(state, payload) {
    state.searchKey = payload;
  },
  SET_IS_LOADING: function SET_IS_LOADING(state, payload) {
    state.isLoading = payload;
  }
};

var getters = {
  getProduct: function getProduct(state) {
    return state.products;
  },
  getSearchKey: function getSearchKey(state) {
    return state.searchKey;
  },
  productsNumber: function productsNumber(state) {
    return state.productsNumber;
  },
  getIsLoading: function getIsLoading(state) {
    return state.isLoading;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http_request__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__ = __webpack_require__(6);










var ProductProvider = function (_HttpRequest) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ProductProvider, _HttpRequest);

  function ProductProvider() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ProductProvider);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProductProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ProductProvider)).call(this, "https://oms-api.akitahub.com/"));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ProductProvider, [{
    key: 'getProduct',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(searchKey) {
        var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        var _ref2, data, results;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["f" /* getStoreBearer */])();

              case 3:
                _context.t1 = _context.sent;
                _context.t2 = {
                  'Authorization': _context.t1
                };

                _context.t0.setHeader.call(_context.t0, _context.t2);

                _context.next = 8;
                return this.get('/product', {
                  is_dm: false,
                  page: page,
                  search: searchKey,
                  warehouse: Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["k" /* getWerehouse */])()
                });

              case 8:
                _ref2 = _context.sent;
                data = _ref2.data;
                results = {
                  products: [],
                  productsNumber: 0
                };

                if (!data.results.length) {
                  _context.next = 16;
                  break;
                }

                _context.next = 14;
                return this.tranfromData(data);

              case 14:
                results.products = _context.sent;

                results.productsNumber = data.results.length;

              case 16:
                return _context.abrupt('return', results);

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getProduct(_x) {
        return _ref.apply(this, arguments);
      }

      return getProduct;
    }()
  }, {
    key: 'tranfromData',
    value: function tranfromData(data) {
      var result = [];
      try {
        data.results.forEach(function (items) {
          var count = 0;
          var options = items.concat_sku_options.split(':;:');
          var images = items.concat_sku_src.split(':;:');
          var prices = items.concat_sku_price.split(':;:');
          var remain = items.concat_lot_remaining.split(':;:');
          var id = items.concat_sku_id.split(':;:');
          var code = items.concat_sku_code.split(':;:');
          var productId = items.id;
          var name = items.name;
          var tags = items.product_tags === null || !items.product_tags ? [] : items.product_tags.split(':;:');
          var categories = items.concat_product_category === null || !items.concat_product_category ? [] : items.concat_product_category.split(':;:');
          items.concat_sku_code.split(':;:').forEach(function (item) {
            var opt = options[count].split(',');
            result.push({
              productId: productId,
              id: id[count],
              code: code[count],
              name: name,
              tags: tags,
              categories: categories,
              amount: 1,
              option: options[count].replace(/,/g, ' '),
              option1: opt[0],
              option2: opt[1],
              variant1: items.variant_1,
              variant2: items.variant_2,
              optionPOSCompleteCart: options[count].replace(/,,/g, '').replace(/,$/g, ''),
              fullPrice: prices[count],
              price: prices[count],
              image: images[count],
              remain: remain[count],
              quantity: 1
            });
            count++;
          });
        });
      } catch (error) {
        console.log(error);
      }
      return result;
    }
  }]);

  return ProductProvider;
}(__WEBPACK_IMPORTED_MODULE_7__http_request__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ProductProvider);

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources_sellsuki_provider__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resources_order_provider__ = __webpack_require__(252);




var orderProvider = new __WEBPACK_IMPORTED_MODULE_3__resources_order_provider__["a" /* default */]();
var sellsukiProvider = new __WEBPACK_IMPORTED_MODULE_2__resources_sellsuki_provider__["a" /* default */]();

var state = {
  sellsukiData: {},
  branch: [],
  initailData: {},
  paymentChannel: [],
  billExpire: 1,
  storeData: {},
  mainColor: '#1b0000'
};

var actions = {
  setSellsukiAuth: function setSellsukiAuth(_ref, payload) {
    var commit = _ref.commit;

    commit('SET_AUTH_SELLSUKI', payload);
  },
  setMainColor: function setMainColor(_ref2, payload) {
    var commit = _ref2.commit;

    commit('SET_MAIN_COLOR', payload);
  },
  fetchBranch: function fetchBranch(_ref3) {
    var _this = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var results;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return sellsukiProvider.fetchBranch();

            case 2:
              results = _context.sent;

              commit('SET_BRANCH', results);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  init: function init(_ref4) {
    var _this2 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _ref5, billExpire, paymentChannel, initData;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return orderProvider.init();

            case 2:
              _ref5 = _context2.sent;
              billExpire = _ref5.billExpire;
              paymentChannel = _ref5.paymentChannel;
              initData = _ref5.initData;

              commit('SET_INITAIL_DATA', initData);
              commit('SET_PAYMENT_CHANNEL', paymentChannel);
              commit('SET_BILL_EXPIRE', billExpire);

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};

var mutations = {
  SET_MAIN_COLOR: function SET_MAIN_COLOR(state, payload) {
    state.mainColor = payload;
  },
  SET_AUTH_SELLSUKI: function SET_AUTH_SELLSUKI(state, payload) {
    state.sellsukiData = payload;
  },
  SET_BRANCH: function SET_BRANCH(state, payload) {
    state.branch = payload;
  },
  SET_INITAIL_DATA: function SET_INITAIL_DATA(state, payload) {
    state.initailData = payload;
  },
  SET_PAYMENT_CHANNEL: function SET_PAYMENT_CHANNEL(state, payload) {
    state.paymentChannel = payload;
  },
  SET_BILL_EXPIRE: function SET_BILL_EXPIRE(state, payload) {
    state.billExpire = payload;
  }
};

var getters = {
  mainColor: function mainColor(state) {
    return state.mainColor;
  },
  storeName: function storeName(state) {
    return state.initailData.store ? state.initailData.store.store_name : '';
  },
  storeColor: function storeColor(state) {
    return state.initailData.store ? state.initailData.store.store_display_photo : '';
  },
  getSellsukiAuth: function getSellsukiAuth(state) {
    return state.sellsukiData;
  },
  getBranch: function getBranch(state) {
    return state.branch;
  },
  storeId: function storeId(state) {
    return state.initailData.store.id;
  },
  initailData: function initailData(state) {
    return state.initailData;
  },
  storeData: function storeData(state) {
    return state.initailData;
  },
  paymentChannel: function paymentChannel(state) {
    return state.paymentChannel;
  },
  billExpire: function billExpire(state) {
    return state.billExpire;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__http_request__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_helper_localStorage__ = __webpack_require__(6);











var SellsukiProvider = function (_HttpRequest) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(SellsukiProvider, _HttpRequest);

  function SellsukiProvider() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, SellsukiProvider);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SellsukiProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(SellsukiProvider)).call(this, "https://oms-api.akitahub.com/"));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(SellsukiProvider, [{
    key: 'fetchBranch',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this2 = this;

        var userCashier, _ref2, results, resultTranformed, result;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = this;
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_9__utils_helper_localStorage__["f" /* getStoreBearer */])();

              case 3:
                _context2.t1 = _context2.sent;
                _context2.t2 = {
                  'Authorization': _context2.t1
                };

                _context2.t0.setHeader.call(_context2.t0, _context2.t2);

                _context2.next = 8;
                return this.getCashier();

              case 8:
                userCashier = _context2.sent;
                _context2.next = 11;
                return this.get('/pos/branch');

              case 11:
                _ref2 = _context2.sent;
                results = _ref2.data.results;
                resultTranformed = this.transformResult(results);
                result = [];

                resultTranformed.map(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(branch) {
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(userCashier.branchID.findIndex(function (b) {
                              return b === branch.id;
                            }) !== -1)) {
                              _context.next = 3;
                              break;
                            }

                            _context.next = 3;
                            return result.push(branch);

                          case 3:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());
                return _context2.abrupt('return', result);

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchBranch() {
        return _ref.apply(this, arguments);
      }

      return fetchBranch;
    }()
  }, {
    key: 'getCashier',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _ref5, results, result;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = this;
                _context3.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_9__utils_helper_localStorage__["f" /* getStoreBearer */])();

              case 3:
                _context3.t1 = _context3.sent;
                _context3.t2 = {
                  'Authorization': _context3.t1
                };

                _context3.t0.setHeader.call(_context3.t0, _context3.t2);

                _context3.next = 8;
                return this.get('/pos/cashier');

              case 8:
                _ref5 = _context3.sent;
                results = _ref5.data.results;
                result = this.mapUserCashier(results);
                return _context3.abrupt('return', result);

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getCashier() {
        return _ref4.apply(this, arguments);
      }

      return getCashier;
    }()
  }, {
    key: 'mapUserCashier',
    value: function mapUserCashier(results) {
      var loginUser = Object(__WEBPACK_IMPORTED_MODULE_9__utils_helper_localStorage__["i" /* getUser */])();
      var filteredCashier = results.find(function (user) {
        return user.id === loginUser.id;
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, filteredCashier, {
        branchID: filteredCashier.concat_cashier_branch_id ? filteredCashier.concat_cashier_branch_id.split(':;:') : [],
        branchName: filteredCashier.concat_cashier_branch_name ? filteredCashier.concat_cashier_branch_name.split(':;:') : []
      });
    }
  }, {
    key: 'transformResult',
    value: function transformResult(results) {
      var data = [];
      results.map(function (item) {
        data.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
          posID: item.concat_pos_id ? item.concat_pos_id.split(':;:') : [],
          unitID: item.concat_unit_id ? item.concat_unit_id.split(':;:') : [],
          posWarehouse: item.concat_pos_warehouse ? item.concat_pos_warehouse.split(':;:') : [],
          posWarehouseDisplayName: item.concat_pos_warehouse_display_name ? item.concat_pos_warehouse_display_name.split(':;:') : []
        }));
      });
      return data;
    }
  }]);

  return SellsukiProvider;
}(__WEBPACK_IMPORTED_MODULE_8__http_request__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SellsukiProvider);

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('showFullPriceFormat', function () {
  var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var str = parseFloat(number).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return str;
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]);

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_home_Home__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_home_ScanToSearch__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_cart_Cart__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_check_out_Payment__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_check_out_CheckoutByCash__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_check_out_CheckoutByCard__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_qrcode_reader__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_user_info_UserInfo__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_report_ReportZ__ = __webpack_require__(469);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_qrcode_reader__["default"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_home_Home__["a" /* default */]
  }, {
    path: '/scan-to-search',
    name: 'ScanToSearch',
    component: __WEBPACK_IMPORTED_MODULE_3__views_home_ScanToSearch__["a" /* default */]
  }, {
    path: '/cart',
    name: 'Cart',
    component: __WEBPACK_IMPORTED_MODULE_4__views_cart_Cart__["a" /* default */]
  }, {
    path: '/payment',
    name: 'Payment',
    component: __WEBPACK_IMPORTED_MODULE_5__views_check_out_Payment__["a" /* default */]
  }, {
    path: '/checkout-by-cash',
    name: 'CheckoutByCash',
    component: __WEBPACK_IMPORTED_MODULE_6__views_check_out_CheckoutByCash__["a" /* default */]
  }, {
    path: '/checkout-by-card',
    name: 'CheckoutByCard',
    component: __WEBPACK_IMPORTED_MODULE_7__views_check_out_CheckoutByCard__["a" /* default */]
  }, {
    path: '/user-info',
    name: 'UserInfo',
    component: __WEBPACK_IMPORTED_MODULE_9__views_user_info_UserInfo__["a" /* default */]
  }, {
    path: '/report-z',
    name: 'ReportZ',
    component: __WEBPACK_IMPORTED_MODULE_10__views_report_ReportZ__["a" /* default */]
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23cf017b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(397);
function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23cf017b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23cf017b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 393:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListProduct_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3481b1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListProduct_vue__ = __webpack_require__(396);
function injectStyle (ssrContext) {
  __webpack_require__(395)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f3481b1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3481b1a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListProduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 395:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.products.length > 1)?_c('div',_vm._l((_vm.products),function(item,index){return _c('div',{key:index,staticClass:"item-list f-left w-100pct pd-vtc-10px al-center dp-flex al-it-center"},[_c('div',{staticClass:"w-30pct f-left"},[_c('img',{attrs:{"src":item.image,"alt":"","width":"60%"}})]),_vm._v(" "),_c('div',{staticClass:"w-40pct f-left t-al-left"},[_c('span',[_c('b',[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),(!item.option.includes('default'))?_c('span',[_vm._v(_vm._s(item.option)+" "),_c('br')]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("In Stock "+_vm._s(item.remain))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("ราคา ฿ "+_vm._s(_vm._f("showFullPriceFormat")(item.price))+" ")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"w-30pct f-left"},[_c('svg-filler',{staticClass:"cs-pointer",attrs:{"path":"/static/svg/basket.svg","fill":'#1b0000',"width":"30px","height":"30px"},on:{"click":function($event){_vm.addItem(item)}}})],1)])})):(_vm.products.length === 1)?_c('div',[_c('img',{staticClass:"w-180px",attrs:{"src":_vm.products[0].image,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"f-s-16px f-w-bold"},[_c('span',[_vm._v(_vm._s(_vm.products[0].name))])]),_vm._v(" "),_c('div',{staticClass:"f-s-16px pd-16px"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.products[0].option1)+" "),_c('br'),_vm._v(" "),(_vm.products[0].option2 !== ' : ')?_c('span',[_vm._v(_vm._s(_vm.products[0].option2)+" "),_c('br')]):_vm._e(),_vm._v("\n        stock : "+_vm._s(_vm.products[0].remain)+" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Price ฿ "+_vm._s(_vm._f("showFullPriceFormat")(_vm.products[0].price)))]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"dp-flex jtf-ct-center"},[_c('div',{staticClass:"minus-item cs-pointer",style:(("background-color: " + _vm.mainColor + ";")),on:{"click":function($event){_vm.amountItem--}}},[_vm._v("\n        -\n      ")]),_vm._v(" "),_c('div',{staticClass:"item-amout-box pd-t-6px"},[_vm._v("\n        "+_vm._s(_vm.amountItem)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"add-item cs-pointer",style:(("background-color: " + _vm.mainColor + ";")),on:{"click":function($event){_vm.amountItem++}}},[_vm._v("\n        +\n      ")])]),_vm._v(" "),_c('div',{staticClass:"pd-vtc-16px"},[_c('div',{staticClass:"add-item-tab f-s-24px f-w-bold pd-8px cl-white cs-pointer",on:{"click":function($event){_vm.addItemData(_vm.products[0])}}},[_vm._v("\n        Add To Cart\n      ")])])]):_c('div',{staticClass:"mg-auto pd-t-100px"},[_c('svg-filler',{attrs:{"path":"/static/svg/QR icon big.svg","fill":'#f2f2f2',"width":"220px","height":"220px"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getBranch())?_c('div',[_c('div',{staticClass:"w-100pct h-60px cl-white f-s-18px f-w-bold pd-5px dp-flex al-it-center jtf-ct-center",style:(("background-color: " + _vm.mainColor + ";"))},[_c('span',{staticClass:"mg-l-10px"},[_vm._v(_vm._s(_vm.storeName)+" | "+_vm._s(_vm.branchName))])]),_vm._v(" "),_c('div',{staticClass:"column is-6 is-offset-3 is-paddingless"},[_c('div',{staticClass:"columns is-centered is-marginless h-60px"},[_c('div',{staticClass:"column"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input-data f-left pd-6px",attrs:{"placeholder":"กรุณาใส่ชื่อสินค้าที่ต้องการค้นหา","type":"search"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"f-left search pd-6px cs-pointer",style:(("background-color: " + _vm.mainColor + ";")),on:{"click":function($event){_vm.searchData()}}},[_c('svg-filler',{attrs:{"path":"/static/svg/search.svg","fill":'#ffffff',"width":"20px","height":"20px"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',[_c('ListProduct',{attrs:{"products":_vm.products,"searchKey":_vm.searchKey},on:{"update:products":function($event){_vm.products=$event},"update:searchKey":function($event){_vm.searchKey=$event}}})],1)])]),_vm._v(" "),_c('div',{staticClass:"w-100pct h-60px cl-white f-s-18px f-w-bold",style:(("background-color: " + _vm.mainColor + ";"))},[_c('div',{staticClass:"columns is-marginless is-paddingless"},[_c('div',{staticClass:"column is-paddingless is-6 is-offset-3 dp-flex jtf-ct-space-between"},[_c('div',{staticClass:"pd-16px"},[_c('router-link',{attrs:{"to":{ name: 'UserInfo' },"exact":""}},[_c('svg-filler',{attrs:{"path":"/static/svg/user.svg","fill":'#ffffff',"width":"24px","height":"24px"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"pd-6px"},[_c('router-link',{attrs:{"to":{ name: 'ScanToSearch' },"exact":""}},[_c('svg-filler',{attrs:{"path":"/static/svg/QR_icon.svg","fill":'#ffffff',"width":"48px","height":"48px"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"pd-r-20px"},[(_vm.amount === 0)?_c('svg-filler',{staticClass:"mg-t-16px",attrs:{"path":"/static/svg/basket.svg","fill":'#ffffff',"width":"24px","height":"24px"}}):_c('router-link',{attrs:{"to":{ name: 'Cart' },"exact":""}},[_c('div',{staticClass:"tag cartItemCount is-danger pst-absolute mg-l-15px mg-t-8px"},[_vm._v("\n                "+_vm._s(_vm.amount)+"\n              ")]),_vm._v(" "),_c('svg-filler',{staticClass:"mg-t-16px",attrs:{"path":"/static/svg/basket.svg","fill":'#ffffff',"width":"24px","height":"24px"}})],1)],1)])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanToSearch_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36a26ccf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScanToSearch_vue__ = __webpack_require__(401);
function injectStyle (ssrContext) {
  __webpack_require__(399)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36a26ccf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanToSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36a26ccf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScanToSearch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 399:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tid.53d97f3.mp3";

/***/ }),

/***/ 401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",style:(("background-color: " + _vm.mainColor + ";"))},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_c('svg-filler',{staticClass:"mg-r-auto f-left cs-pointer",attrs:{"path":"/static/svg/back.svg","fill":'#ffffff',"width":"20px","height":"20px"}})],1),_vm._v(" "),_c('span',[_vm._v("\n      Scan QR code\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"list-item"},[_c('div',{staticClass:"pst-fixed mg-auto t-0px l-0px r-0px bt-0px w-fit-content h-fit-content t-al-center "},[_c('qrcode-reader',{staticClass:"qrcode",on:{"decode":_vm.onDecode}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f28b2f1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__ = __webpack_require__(453);
function injectStyle (ssrContext) {
  __webpack_require__(403)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f28b2f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f28b2f1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 403:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListCart_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fe92752_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListCart_vue__ = __webpack_require__(406);
function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fe92752"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListCart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fe92752_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListCart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 405:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100pct"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"item-list f-left w-100pct pd-vtc-10px al-center"},[_c('div',{staticClass:"w-15pct f-left"},[_c('img',{attrs:{"src":item.image,"alt":"","width":"100%"}})]),_vm._v(" "),_c('div',{staticClass:"w-85pct f-left t-al-left pd-l-10px"},[_c('div',[_c('span',{staticClass:"f-s-16px f-w-bold"},[_vm._v(_vm._s(item.name)+" ("+_vm._s(item.code)+") ")])]),_vm._v(" "),_c('div',[_c('span',{},[_vm._v(_vm._s(item.option))])]),_vm._v(" "),_c('div',{staticClass:"dp-flex jtf-ct-space-between"},[_c('div',{staticClass:"w-80pct"},[_vm._v("\n          ฿ "+_vm._s(_vm._f("showFullPriceFormat")(item.price))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"w-20pct"},[_c('svg-filler',{staticClass:"cs-pointer",attrs:{"path":"/static/svg/trash-alt-regular.svg","fill":'#1b0000',"width":"20px","height":"20px"},on:{"click":function($event){_vm.confirmCustomDelete(item)}}})],1)])])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",style:(("background-color: " + _vm.mainColor + ";"))},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_c('svg-filler',{staticClass:"mg-r-auto f-left cs-pointer",attrs:{"path":"/static/svg/back.svg","fill":'#ffffff',"width":"20px","height":"20px"}})],1),_vm._v(" "),_c('span',[_vm._v("\n      มีสินค้าในตระกร้าจำนวน "+_vm._s(_vm.amount)+" ชิ้น\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"columns is-marginless is-centered"},[_c('div',{staticClass:"list-item column is-6 is-marginless pd-20px"},[_c('div',{staticClass:"columns is-marginless is-paddingless"},[_c('list-cart',{attrs:{"items":_vm.items},on:{"clearPromotionCode":_vm.clearPromotionCode}})],1),_vm._v(" "),_c('div',{staticClass:"columns is-marginless is-paddingless f-left w-100pct"},[_c('div',{staticClass:"column is-6 is-offset-3"},[_c('div',{staticClass:"mg-auto clear-item mg-hrzt-auto cl-white f-w-bold pd-6px cs-pointer",on:{"click":function($event){_vm.clear()}}},[_vm._v("ล้างรายการ")])])])])]),_vm._v(" "),_c('div',{staticClass:"cart-data columns is-marginless is-centered"},[_c('div',{staticClass:"column is-6 is-marginless pd-20px"},[_c('div',{staticClass:"f-s-16px f-w-bold t-al-left"},[_vm._v("\n        เบอร์โทรศัพท์\n      ")]),_vm._v(" "),(!_vm.isTel)?_c('div',[_c('VueTelInput',{staticClass:"input-data f-left pd-6px",attrs:{"preferredCountries":['us', 'gb', 'ua', 'th']},on:{"onInput":_vm.onInputTel},model:{value:(_vm.tel),callback:function ($$v) {_vm.tel=$$v},expression:"tel"}}),_vm._v(" "),_c('div',{staticClass:"f-left cl-light f-w-bold search pd-6px cs-pointer",style:(("background-color: " + _vm.mainColor + ";")),on:{"click":function($event){_vm.setMemberTel()}}},[_vm._v("\n          confirm\n        ")])],1):_c('div',[_c('VueTelInput',{staticClass:"input-data f-left pd-6px",attrs:{"disabled":true},model:{value:(_vm.tel),callback:function ($$v) {_vm.tel=$$v},expression:"tel"}}),_vm._v(" "),_c('div',{staticClass:"f-left pd-6px cs-pointer search cl-light f-w-bold",style:(("background-color: " + _vm.mainColor + ";")),on:{"click":function($event){_vm.changTel()}}},[_vm._v("\n          Clear\n        ")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"f-s-16px f-w-bold t-al-left"},[_vm._v("\n        รหัสส่วนลดพิเศษ \n      ")]),_vm._v(" "),(!_vm.isCode)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoCode),expression:"promoCode"}],staticClass:"input-data f-left pd-6px",attrs:{"placeholder":"A-1234"},domProps:{"value":(_vm.promoCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promoCode=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"f-left search pd-6px cs-pointer",style:(("background-color: " + _vm.mainColor + ";")),on:{"click":function($event){_vm.verifyCode()}}},[_c('svg-filler',{attrs:{"path":"/static/svg/search.svg","fill":'#ffffff',"width":"20px","height":"20px"}})],1)]):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoCode),expression:"promoCode"}],staticClass:"input-data f-left pd-6px",attrs:{"placeholder":"A-1234","disabled":"disabled"},domProps:{"value":(_vm.promoCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promoCode=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"f-left search pd-6px cs-pointer cl-light f-w-bold",style:(("background-color: " + _vm.mainColor + ";")),on:{"click":function($event){_vm.changCode()}}},[_vm._v("\n          Clear\n        ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"dp-flex jtf-ct-space-between f-s-16px f-w-bold"},[_c('div',{staticClass:"w-50pct t-al-left"},[_vm._v("\n          ราคารวม\n        ")]),_vm._v(" "),_c('div',{staticClass:"w-50pct t-al-right"},[_vm._v("\n          ฿ "+_vm._s(_vm._f("showFullPriceFormat")(_vm.getFullPrice))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"dp-flex jtf-ct-space-between f-s-16px f-w-bold"},[_c('div',{staticClass:"w-80pct t-al-left"},[_vm._v("\n          ส่วนลดพิเศษ\n        ")]),_vm._v(" "),_c('div',{staticClass:"w-50pct t-al-right"},[_vm._v("\n          ฿ "),(_vm.discount > 0)?_c('span',[_vm._v("-")]):_vm._e(),_vm._v(_vm._s(_vm._f("showFullPriceFormat")(_vm.discount))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"dp-flex jtf-ct-space-between f-s-16px f-w-bold"},[_c('div',{staticClass:"w-50pct t-al-left"},[_vm._v("\n          ราคาสุทธิ\n        ")]),_vm._v(" "),_c('div',{staticClass:"w-50pct t-al-right"},[_vm._v("\n          ฿ "+_vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"dp-flex jtf-ct-space-between f-w-bold"},[_c('div',{staticClass:"add-item-btn cs-pointer",style:(("background-color: " + _vm.mainColor + ";")),on:{"click":function($event){_vm.$router.push({ name: 'ScanToSearch' })}}},[_vm._v("\n          + เพิ่มสินค้า\n        ")]),_vm._v(" "),_c('div',{staticClass:"checkout-btn cs-pointer",on:{"click":function($event){_vm.confirm()}}},[_vm._v("\n          ชำระเงิน ("+_vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice))+" ฿)\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_628eb3ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__(455);
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_628eb3ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",style:(("background-color: " + _vm.mainColor + ";"))},[_c('router-link',{attrs:{"to":{ name: 'Cart' }}},[_c('svg-filler',{staticClass:"mg-r-auto f-left cs-pointer",attrs:{"path":"/static/svg/back.svg","fill":'#ffffff',"width":"20px","height":"20px"}})],1),_vm._v(" "),_c('span',[_vm._v("\n      ช่องทางการชำระเงิน\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"w-100pct h-60calc"},[_c('div',{staticClass:"t-al-center f-s-24px f-w-bold pd-t-48px"},[_vm._v("\n      ราคา "+_vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice))+" บาท\n    ")]),_vm._v(" "),_c('div',{staticClass:"t-al-center f-s-18px mg-t-48px"},[_c('router-link',{attrs:{"to":{ name: 'CheckoutByCard' }}},[_c('img',{staticClass:"w-174px",attrs:{"src":"/static/svg/credit.svg"}}),_vm._v(" "),_c('br')]),_vm._v("\n      ชำระด้วยบัตรเครดิต\n    ")],1),_vm._v(" "),_c('div',{staticClass:"t-al-center f-s-18px mg-t-48px"},[_c('router-link',{attrs:{"to":{ name: 'CheckoutByCash' }}},[_c('img',{staticClass:"w-174px",attrs:{"src":"/static/svg/cash.svg"}}),_vm._v(" "),_c('br')]),_vm._v("\n      ชำระด้วยเงินสด\n    ")],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckoutByCash_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8c0634_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckoutByCash_vue__ = __webpack_require__(460);
function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a8c0634"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckoutByCash_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8c0634_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckoutByCash_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 457:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-cl-white body-box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"columns is-marginless is-paddingless is-centered bd-rd-4px"},[_c('div',{staticClass:"column is-4"},[_vm._l((_vm.printers),function(printer,index){return _c('div',{key:index,staticClass:"printer mg-10px pd-6px f-w-bold t-al-center cs-pointer",style:(("background-color: " + _vm.mainColor + ";")),on:{"click":function($event){_vm.finishPrint(printer.ip)}}},[_vm._v("\n        "+_vm._s(printer.name)+" "),_c('br'),_vm._v(" "+_vm._s(printer.ip)+"\n      ")])}),_vm._v(" "),_c('div',{staticClass:"no-print mg-10px pd-18px f-w-bold cs-pointer",on:{"click":function($event){_vm.finishPrint('no print')}}},[_vm._v("\n        ไม่พิมพ์ใบเสร็จ\n      ")])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100pct h-60px bg-cl-light cl-black f-s-22px f-w-bold pd-18px t-al-center"},[_c('span',[_vm._v("\n      พิมพ์ใบเสร็จ\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",style:(("background-color: " + _vm.mainColor + ";"))},[_c('router-link',{attrs:{"to":{ name: 'Payment' }}},[_c('svg-filler',{staticClass:"mg-r-auto f-left cs-pointer",attrs:{"path":"/static/svg/back.svg","fill":'#ffffff',"width":"20px","height":"20px"},on:{"click":function($event){_vm.clear()}}})],1),_vm._v(" "),_c('span',[_vm._v("\n        ชำระเงินด้วยเงินสด\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"w-100pct h-60calc"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mg-t-23px f-s-16px f-w-bold"},[_c('span',[_vm._v("ยอดที่ต้องชำระ ฿ "+_vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice)))])]),_vm._v(" "),_c('div',{staticClass:"mg-t-16px f-s-14px"},[_vm._v("\n        ใส่จำนวนเงินที่ได้รับ\n      ")]),_vm._v(" "),_c('div',{staticClass:"mg-t-8px f-s-14px w-300px mg-auto"},[_c('div',{staticClass:"price-btn pd-8px cs-pointer mg-l-7px f-left",on:{"click":function($event){_vm.addReceive(1000)}}},[_vm._v("\n          1,000\n        ")]),_vm._v(" "),_c('div',{staticClass:"price-btn pd-8px cs-pointer mg-l-7px f-left",on:{"click":function($event){_vm.addReceive(2000)}}},[_vm._v("\n          2,000\n        ")]),_vm._v(" "),_c('div',{staticClass:"price-btn pd-8px cs-pointer mg-l-7px f-left",on:{"click":function($event){_vm.addReceive(3000)}}},[_vm._v("\n          3,000\n        ")]),_vm._v(" "),_c('div',{staticClass:"price-btn pd-8px cs-pointer mg-l-7px f-left",on:{"click":function($event){_vm.addReceive(5000)}}},[_vm._v("\n          5,000\n        ")]),_vm._v(" "),_c('div',{staticClass:"price-btn pd-8px cs-pointer mg-l-7px f-left",on:{"click":function($event){_vm.clear()}}},[_vm._v("\n          Clear\n        ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"pd-t-8px f-s-14px w-190px mg-auto"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.receive),expression:"receive"}],staticClass:"price-inp pd-6px f-left",attrs:{"type":"number","placeholder":"0,000","min":"0"},domProps:{"value":(_vm.receive)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.receive=$event.target.value},function($event){_vm.calculatedChange({receive: _vm.receive, netPrice: _vm.netPrice})}]}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"mg-t-10px f-s-16px f-w-bold"},[_vm._v("\n        จำนวนเงินทอน "),_c('br'),_vm._v("\n        ฿ "+_vm._s(_vm._f("showFullPriceFormat")(_vm.change))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"mg-t-13px f-s-16px f-w-bold"},[(_vm.receivedCash < _vm.netPrice || _vm.fullPrice === 0)?_c('div',{staticClass:"checkout-btn cs-not-allowed mg-auto pd-8px",style:(("background-color: " + _vm.mainColor + ";"))},[_vm._v(" ชำระเงินเสร็จสิ้น ")]):_c('div',{staticClass:"checkout-btn cs-pointer mg-auto pd-8px",style:(("background-color: " + _vm.mainColor + ";")),on:{"click":function($event){_vm.finishCheckout('Cash')}}},[_vm._v(" ชำระเงินเสร็จสิ้น ")])])])]),_vm._v(" "),_c('b-modal',{attrs:{"active":_vm.activeModal,"canCancel":[]},on:{"update:active":function($event){_vm.activeModal=$event}}},[_c('SelectPrinter')],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pd-t-13px"},[_c('img',{staticClass:"w-78px",attrs:{"src":"/static/img/icons/apple-touch-icon-180x180.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckoutByCard_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc86d5d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckoutByCard_vue__ = __webpack_require__(463);
function injectStyle (ssrContext) {
  __webpack_require__(462)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cc86d5d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckoutByCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc86d5d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckoutByCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 462:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",style:(("background-color: " + _vm.mainColor + ";"))},[_c('router-link',{attrs:{"to":{ name: 'Payment' }}},[_c('svg-filler',{staticClass:"mg-r-auto f-left cs-pointer",attrs:{"path":"/static/svg/back.svg","fill":'#ffffff',"width":"20px","height":"20px"}})],1),_vm._v(" "),_c('span',[_vm._v("\n        ชำระเงินด้วยบัตรเครดิต\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"w-100pct h-60calc"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mg-t-23px f-s-16px f-w-bold"},[_c('span',[_vm._v("ยอดที่ต้องชำระ ฿ "+_vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice)))])]),_vm._v(" "),_c('div',{staticClass:"mg-t-23px f-s-16px f-w-bold"},[(_vm.fullPrice === 0)?_c('div',{staticClass:"checkout-btn cs-not-allowed mg-auto pd-8px",style:(("background-color: " + _vm.mainColor + ";"))},[_vm._v(" ชำระเงินเสร็จสิ้น ")]):_c('div',{staticClass:"checkout-btn cs-pointer mg-auto pd-8px",style:(("background-color: " + _vm.mainColor + ";")),on:{"click":function($event){_vm.finishCheckout('Credit')}}},[_vm._v(" ชำระเงินเสร็จสิ้น ")])])])]),_vm._v(" "),_c('b-modal',{attrs:{"active":_vm.activeModal,"canCancel":[]},on:{"update:active":function($event){_vm.activeModal=$event}}},[_c('SelectPrinter')],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pd-t-23px"},[_c('img',{staticClass:"w-78px",attrs:{"src":"/static/img/icons/apple-touch-icon-180x180.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 466:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInfo_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e2c6e5a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInfo_vue__ = __webpack_require__(468);
function injectStyle (ssrContext) {
  __webpack_require__(467)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e2c6e5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e2c6e5a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 467:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",style:(("background-color: " + _vm.mainColor + ";"))},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_c('svg-filler',{staticClass:"mg-r-auto f-left cs-pointer",attrs:{"path":"/static/svg/back.svg","fill":'#ffffff',"width":"20px","height":"20px"}})],1),_vm._v(" "),_c('span',[_vm._v(" ข้อมูลของฉัน ")])],1),_vm._v(" "),_c('div',{staticClass:"w-100pct h-60calc"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"t-al-center f-s-18px f-w-bold"},[_vm._v("\n      "+_vm._s(_vm.userInfo.user.first_name)+"  "+_vm._s(_vm.userInfo.user.last_name)+"\n    ")]),_vm._v(" "),_c('table',{staticClass:"table t-al-center f-s-18px mg-auto pd-hrzt-10px"},[_c('tr',[_c('td',[_vm._v(" EmpNo. ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.userInfo.user.id)+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(" Branch name ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.userInfo.user.branch_name)+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(" POS ID ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.userInfo.user.pos_id)+" ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n            E-mail\n          ")]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.userInfo.user.email)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"t-al-center mg-t-16px"},[_c('router-link',{attrs:{"to":{ name: 'ReportZ' },"exact":""}},[_c('div',{staticClass:"reportZ-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px cl-white",style:(("background-color: " + _vm.mainColor + ";"))},[_vm._v(" รายงานสรุปยอดประจำวัน ")])])],1),_vm._v(" "),_c('div',{staticClass:"t-al-center mg-t-16px"},[_c('div',{staticClass:"reportZ-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px cl-white",style:(("background-color: " + _vm.mainColor + ";")),on:{"click":function($event){_vm.changeBranch()}}},[_vm._v(" เปลี่ยนสาขา ")])]),_vm._v(" "),_c('div',{staticClass:"t-al-center mg-t-21px"},[_c('div',{staticClass:"logOut-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px",on:{"click":function($event){_vm.logout()}}},[_vm._v(" ออกจากระบบ ")])])]),_vm._v(" "),_c('b-modal',{attrs:{"active":_vm.activeModal,"canCancel":[]},on:{"update:active":function($event){_vm.activeModal=$event},"close":function($event){_vm.getBranchNameDisplay()}}},[_c('selectStore',{attrs:{"cancelBtn":true}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-al-center"},[_c('img',{staticStyle:{"width":"228px"},attrs:{"src":"/static/img/image/sellsuki.PNG"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportZ_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f5d984_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportZ_vue__ = __webpack_require__(472);
function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58f5d984"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportZ_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f5d984_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportZ_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__http_request__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);











var ReportProvider = function (_HttpRequest) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ReportProvider, _HttpRequest);

  function ReportProvider() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ReportProvider);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ReportProvider.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ReportProvider)).call(this, "https://oms-api.akitahub.com/"));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ReportProvider, [{
    key: 'getReportZ',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(date) {
        var _ref2, results;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["f" /* getStoreBearer */])();

              case 3:
                _context.t1 = _context.sent;
                _context.t2 = {
                  'Authorization': _context.t1
                };

                _context.t0.setHeader.call(_context.t0, _context.t2);

                _context.next = 8;
                return this.get('/pos/report-z', {
                  date: date,
                  pos_unit_id: Object(__WEBPACK_IMPORTED_MODULE_8__utils_helper_localStorage__["h" /* getUnitID */])()
                });

              case 8:
                _ref2 = _context.sent;
                results = _ref2.data.results;


                if (results.last_bill.length !== 0) {
                  results.last_bill[0].create_time = __WEBPACK_IMPORTED_MODULE_9_moment___default()(results.last_bill[0].create_time).add(7, 'hours').format('DD-MM-YYYY HH:mm');
                }
                if (results.first_bill.length !== 0) {
                  results.first_bill[0].create_time = __WEBPACK_IMPORTED_MODULE_9_moment___default()(results.first_bill[0].create_time).add(7, 'hours').format('DD-MM-YYYY HH:mm');
                }
                return _context.abrupt('return', results);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getReportZ(_x) {
        return _ref.apply(this, arguments);
      }

      return getReportZ;
    }()
  }]);

  return ReportProvider;
}(__WEBPACK_IMPORTED_MODULE_7__http_request__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ReportProvider);

/***/ }),

/***/ 472:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",style:(("background-color: " + _vm.mainColor + ";"))},[_c('router-link',{attrs:{"to":{ name: 'UserInfo' }}},[_c('svg-filler',{staticClass:"mg-r-auto f-left cs-pointer",attrs:{"path":"/static/svg/back.svg","fill":'#ffffff',"width":"20px","height":"20px"}})],1),_vm._v(" "),_c('span',[_vm._v("\n      รายงานสรุปยอดประจำวัน\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"columns is-centered is-marginless"},[_c('div',{staticClass:"h-60calc mg-t-16px pd-hrzt-35px column is-4"},[_c('div',{staticClass:"dp-flex jtf-ct-space-between "},[_c('div',{staticClass:"f-left f-s-14px f-w-bold"},[_vm._v("เลือกวันที่")]),_vm._v(" "),_c('div',{staticClass:"f-right w-62pct"},[_c('b-datepicker',{attrs:{"placeholder":"เลือกวันที่ ที่ต้องการพิมพ์","icon":"calendar-today","max-date":_vm.maxDate},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"dp-flex jtf-ct-space-between mg-t-16px"},[_c('div',{staticClass:"f-left f-s-14px f-w-bold"},[_vm._v("เงินตั้งต้น")]),_vm._v(" "),_c('div',{staticClass:"f-right w-62pct"},[_c('b-input',{attrs:{"type":"number","min":"0"},model:{value:(_vm.startPrice),callback:function ($$v) {_vm.startPrice=$$v},expression:"startPrice"}})],1)]),_vm._v(" "),_c('div',{staticClass:"dp-flex jtf-ct-space-between mg-t-16px"},[_c('div',{staticClass:"f-left f-s-14px f-w-bold"},[_vm._v("ยอดงานนำส่ง")]),_vm._v(" "),_c('div',{staticClass:"f-right w-62pct"},[_c('b-input',{attrs:{"type":"number","min":"0"},model:{value:(_vm.givePrice),callback:function ($$v) {_vm.givePrice=$$v},expression:"givePrice"}})],1)]),_vm._v(" "),_c('div',{staticClass:"dp-flex jtf-ct-space-between mg-t-16px"},[_c('div',{staticClass:"f-left f-s-14px f-w-bold"},[_vm._v("เครื่องปริ้น")]),_vm._v(" "),_c('div',{staticClass:"f-right w-62pct"},[_c('b-select',{attrs:{"expanded":"","placeholder":"เลือก Printer"},model:{value:(_vm.selectedPrinter),callback:function ($$v) {_vm.selectedPrinter=$$v},expression:"selectedPrinter"}},_vm._l((_vm.printers),function(printer,index){return _c('option',{key:index,domProps:{"value":printer.ip}},[_vm._v(_vm._s(printer.name))])}))],1)]),_vm._v(" "),_c('div',{staticClass:"columns is-marginless"},[((((_vm.startPrice === '' || _vm.startPrice === '0') || (_vm.givePrice === '' || _vm.givePrice === '0')) || _vm.selectedPrinter === '' ))?_c('div',{staticClass:"disabled mg-auto pd-vtc-5px pd-hrzt-2px mg-t-16px"},[_vm._v(" พิมพ์รายงาน ")]):_c('div',{staticClass:"print-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px mg-t-16px",style:(("background-color: " + _vm.mainColor + ";")),on:{"click":function($event){_vm.print()}}},[_vm._v(" พิมพ์รายงาน ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 476:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PrepareLogin_vue__ = __webpack_require__(287);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fd34ecf6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PrepareLogin_vue__ = __webpack_require__(481);
function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd34ecf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PrepareLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fd34ecf6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PrepareLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 48:
/***/ (function(module, exports) {

module.exports = {
  '56940': {
    name: 'A',
    id: '5e3548c6d32cb12606a34fba'
  },
  '56983': {
    name: 'Chou',
    id: '5ee750bfaf5cfe001a6f40da'
  },
  '56981': {
    name: 'Mustard sneakers',
    id: '5ee75026af5cfe001a6f40cf'
  },
  '56982': {
    name: 'Tallulah',
    id: '5ee74ff0af5cfe001a6f40c0'
  },
  '56984': {
    name: 'A pale petal',
    id: '5ef2db51b74c35001afef205'
  }
};

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.PdogLoad),expression:"PdogLoad"}],staticClass:"prepare-login-container"},[_c('img',{staticClass:"suki-logo",attrs:{"src":"https://oms.akitahub.com/img/dog_loading.gif"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 483:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getStoreBearer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBranchID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getUnitID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getUserCashier; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPOSID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getWerehouse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBranchName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSellsukiUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentBranchPOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getStoreId; });

var getStoreBearer = function getStoreBearer() {
  var auth = window.localStorage.getItem('sellsuki.store.bearer');
  return auth;
};

var getSellsukiUser = function getSellsukiUser() {
  var user = window.localStorage.getItem('sellsuki.user');
  user = JSON.parse(user);
  return user;
};

var getUser = function getUser() {
  var user = window.localStorage.getItem('sellsuki.user');
  user = JSON.parse(user);
  var result = {
    id: user.user.id ? user.user.id : '',
    first_name: user.user.first_name ? user.user.first_name : '',
    last_name: user.user.last_name ? user.user.last_name : ''
  };
  return result;
};
function getUserCashier() {
  var user = window.localStorage.getItem('sellsuki.user');
  user = JSON.parse(user);
  var result = {
    id: user.user.id ? parseInt(user.user.id) : 0,
    name: user.user.first_name ? user.user.first_name + ' ' + user.user.last_name : '',
    email: user.user.email ? user.user.email : ''
  };
  return result;
}

var getBranchID = function getBranchID() {
  var results = window.localStorage.getItem('currentBranchPOS');
  return JSON.parse(results).branch_id;
};
var getUnitID = function getUnitID() {
  var results = window.localStorage.getItem('currentBranchPOS');
  return JSON.parse(results).unit_id;
};
var getPOSID = function getPOSID() {
  var results = window.localStorage.getItem('currentBranchPOS');
  return JSON.parse(results).pos_id;
};
var getWerehouse = function getWerehouse() {
  var results = window.localStorage.getItem('currentBranchPOS');
  return JSON.parse(results) ? JSON.parse(results).warehouse : '';
};
var getBranchName = function getBranchName() {
  var results = window.localStorage.getItem('currentBranchPOS');
  return results ? JSON.parse(results).name : '';
};
var getCurrentBranchPOS = function getCurrentBranchPOS() {
  var getItem = window.localStorage.getItem('currentBranchPOS');
  var result = getItem ? JSON.parse(getItem) : '';
  return result;
};

var getStoreId = function getStoreId() {
  var getItem = window.localStorage.getItem('currentBranchPOS');
  var result = getItem ? JSON.parse(getItem).store_id : '000000000';
  return result;
};


/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_selectStore__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_helper_localStorage__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentEnv: "production",
      activeModal: false,
      isUpToDate: true,
      storeColors: {
        '56940': {
          name: 'A',
          color: '#1b0000'
        },
        '56983': {
          name: 'Chou',
          color: '#703b02'
        },
        '56981': {
          name: 'Mustard sneakers',
          color: '#5c3700'
        },
        '56982': {
          name: 'Tallulah',
          color: '#8b5057'
        },
        '56984': {
          name: 'A pale petal',
          color: '#004D40'
        }
      }
    };
  },

  components: {
    selectStore: __WEBPACK_IMPORTED_MODULE_5__views_selectStore__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['setSellsukiAuth', 'initState', 'setIsloading', 'init', 'setMainColor']), {
    checkVersion: function checkVersion() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/static/version.txt?t=' + Date.now()).then(function (response) {
        var clientScriptVersion = window.sellsukiVersion.trim();
        var serverScriptVersion = response.data.trim();
        if (clientScriptVersion === serverScriptVersion) {
          vm.isUpToDate = true;
        } else {
          vm.isUpToDate = false;
          vm.$dialog.confirm({
            title: 'CHECK VERSION UPDATE',
            message: 'Your version is behide, Please reload to latest version.',
            onConfirm: function onConfirm() {
              vm.setSellsukiAuth('');
              window.localStorage.removeItem('currentBranchPOS');
              window.location.href = "https://oms-login.akitahub.com/#/logout?target=seller-pos";
            }
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    sellsukiAuth: 'getSellsukiAuth',
    isLoading: 'getIsLoading',
    initailData: 'initailData',
    storeId: 'storeId'
  })),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var mainColor, currentBranchPOS;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setIsloading(true);
              _context.next = 3;
              return _this.initState();

            case 3:
              _context.prev = 3;
              _context.next = 6;
              return _this.init();

            case 6:
              _context.next = 15;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](3);

              console.log(_context.t0);
              _this.setSellsukiAuth('');
              _this.firebaseLogout();
              window.localStorage.removeItem('currentBranchPOS');
              window.location.href = "https://oms-login.akitahub.com/#/logout?target=seller-pos";

            case 15:
              mainColor = _this.storeColors[_this.storeId] ? _this.storeColors[_this.storeId] : {
                name: 'A',
                color: '#1b0000'
              };

              _this.setMainColor(mainColor.color);

              if (_this.sellsukiAuth) {
                _context.next = 20;
                break;
              }

              _context.next = 20;
              return _this.setSellsukiAuth(_this.$sellsuki_auth.getSellsukiData());

            case 20:
              currentBranchPOS = Object(__WEBPACK_IMPORTED_MODULE_6__utils_helper_localStorage__["c" /* getCurrentBranchPOS */])();

              console.log(_this.sellsukiAuth.storeId);
              if (!currentBranchPOS || !currentBranchPOS.store_id) {
                _this.activeModal = true;
              }
              _this.setIsloading(false);

            case 24:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 8]]);
    }))();
  },
  created: function created() {
    this.checkVersion();
    setInterval(this.checkVersion, 60000);
  }
});

/***/ })

},[288]);


// WEBPACK FOOTER //
// static/js/app.91e89a5e2859be423749.js